var CustomEvents = { cartItemAdded: "flu:cart:item-added" },
    getRemovedItem = function e() {
        let t = [],
            i = [],
            a = {};
        jQuery.getJSON("/cart.js", function (e) {
            listOfIdsBeforeRemoving = (t = e.items).map((e) => e.id);
        }),
            setTimeout(() => {
                jQuery.getJSON("/cart.js", function (e) {
                    listOfIdsAfterRemoving = (i = e.items).map((e) => e.id);
                    let o = listOfIdsBeforeRemoving.filter((e) => -1 == listOfIdsAfterRemoving.indexOf(e))[0];
                    datalayerRemoveItem((a = t.find((e) => e.id === o)));
                });
            }, "1000");
    },
    dispatchCustomEvent = function e(t) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = new CustomEvent(t, i ? { detail: i } : null);
        document.dispatchEvent(a);
    };
let LAST_PRODUCT_SELECTED = {};
!(function (e) {
    var t,
        i,
        a,
        o,
        n,
        s,
        r,
        c,
        l,
        d,
        e = (jQuery = e),
        u = { sections: [] };
    theme.Shopify = {
        formatMoney: function e(t, i) {
            function a(e, t) {
                return void 0 === e ? t : e;
            }
            function o(e, t, i, o) {
                if (((t = a(t, 2)), (i = a(i, ",")), (o = a(o, ".")), isNaN(e) || null == e)) return 0;
                var n = (e = (e / 100).toFixed(t)).split(".");
                return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? o + n[1] : "");
            }
            "string" == typeof t && (t = t.replace(".", ""));
            var n = "",
                s = /\{\{\s*(\w+)\s*\}\}/,
                r = i || this.money_format;
            switch (r.match(s)[1]) {
                case "amount":
                    n = o(t, 2);
                    break;
                case "amount_no_decimals":
                    n = o(t, 0);
                    break;
                case "amount_with_comma_separator":
                    n = o(t, 2, ".", ",");
                    break;
                case "amount_with_space_separator":
                    n = o(t, 2, " ", ",");
                    break;
                case "amount_with_period_and_space_separator":
                    n = o(t, 2, " ", ".");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    n = o(t, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    n = o(t, 0, " ", "");
                    break;
                case "amount_with_apostrophe_separator":
                    n = o(t, 2, "'", ".");
                    break;
                case "amount_with_decimal_separator":
                    n = o(t, 2, ".", ".");
            }
            return r.replace(s, n);
        },
        formatImage: function e(t, i) {
            return t ? t.replace(/^(.*)\.([^\.]*)$/g, "$1_" + i + ".$2") : "";
        },
        Image: {
            imageSize: function e(t) {
                var i = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== i ? i[1] : null;
            },
            getSizedImageUrl: function e(t, i) {
                if (null == i) return t;
                if ("master" == i) return this.removeProtocol(t);
                var a = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != a) {
                    var o = t.split(a[0]),
                        n = a[0];
                    return this.removeProtocol(o[0] + "_" + i + n);
                }
                return null;
            },
            removeProtocol: function e(t) {
                return t.replace(/http(s)?:/, "");
            },
        },
    };
    class h {
        constructor(t) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(t),
                a = this;
            (this.instances = []),
                e(document).on("cc:component:load", function (o, n, s) {
                    n === t &&
                        e(s)
                            .find("".concat(i, ":not(.cc-initialized)"))
                            .each(function () {
                                a.init(this);
                            });
                }),
                e(document).on("cc:component:unload", function (o, n, s) {
                    n === t &&
                        e(s)
                            .find(i)
                            .each(function () {
                                a.destroy(this);
                            });
                }),
                e(i).each(function () {
                    a.init(this);
                });
        }
        init(t) {
            e(t).addClass("cc-initialized");
        }
        destroy(t) {
            e(t).removeClass("cc-initialized");
        }
        registerInstance(e, t) {
            this.instances.push({ container: e, instance: t });
        }
        destroyInstance(e) {
            this.instances = this.instances.filter((t) => {
                if (t.container === e) return "function" == typeof t.instance.destroy && t.instance.destroy(), t.container !== e;
            });
        }
    }
    (t = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
        (a = 200),
        window.addEventListener(
            "scroll",
            ((i = function () {
                window.dispatchEvent(t);
            }),
            (o = -1),
            (n = !1),
            function () {
                clearTimeout(o),
                    (o = setTimeout(i, a)),
                    n ||
                        (i.call(),
                        (n = !0),
                        setTimeout(function () {
                            n = !1;
                        }, a));
            })
        ),
        (theme.Sections = new (function () {
            var t = this;
            (t._instances = []),
                (t._deferredSectionTargets = []),
                (t._sections = []),
                (t._deferredLoadViewportExcess = 300),
                (t._deferredWatcherRunning = !1),
                (t.init = function () {
                    e(document)
                        .on("shopify:section:load", function (e) {
                            var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
                            i && t.sectionLoad(i);
                        })
                        .on("shopify:section:unload", function (e) {
                            var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
                            i && t.sectionUnload(i);
                        })
                        .on("shopify:section:reorder", function (e) {
                            var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
                            i && t.sectionReorder(i);
                        }),
                        e(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", t._processDeferredSections),
                        (t._deferredWatcherRunning = !0);
                }),
                (t.register = function (i, a, o) {
                    t._sections.push({ type: i, section: a, afterSectionLoadCallback: o ? o.afterLoad : null, afterSectionUnloadCallback: o ? o.afterUnload : null }),
                        e('[data-section-type="' + i + '"]').each(function () {
                            Shopify.designMode || (o && !1 === o.deferredLoad) || !t._deferredWatcherRunning ? t.sectionLoad(this) : t.sectionDeferredLoad(this, o);
                        });
                }),
                (t.sectionDeferredLoad = function (e, i) {
                    t._deferredSectionTargets.push({ target: e, deferredLoadViewportExcess: i && i.deferredLoadViewportExcess ? i.deferredLoadViewportExcess : t._deferredLoadViewportExcess }), t._processDeferredSections(!0);
                }),
                (t._processDeferredSections = function (i) {
                    if (t._deferredSectionTargets.length)
                        for (var a = e(window).scrollTop(), o = a + e(window).height(), n = !0 === i ? t._deferredSectionTargets.length - 1 : 0, s = n; s < t._deferredSectionTargets.length; s++) {
                            var r = t._deferredSectionTargets[s].target,
                                c = t._deferredSectionTargets[s].deferredLoadViewportExcess,
                                l = e(r).offset().top - c,
                                d = l > a && l < o;
                            if (!d) {
                                var u = l + e(r).outerHeight() + 2 * c;
                                d = u > a && u < o;
                            }
                            (d || (l < a && u > o)) && (t.sectionLoad(r), t._deferredSectionTargets.splice(s, 1), s--);
                        }
                    !0 !== i && 0 === t._deferredSectionTargets.length && ((t._deferredWatcherRunning = !1), e(window).off(".themeSectionDeferredLoader"));
                }),
                (t.sectionLoad = function (i) {
                    var i = i,
                        a = t._sectionForTarget(i),
                        o = !1;
                    if (!1 !== (o = a.section ? a.section : a)) {
                        var n = { target: i, section: o, $shopifySectionContainer: e(i).closest(".shopify-section"), thisContext: { functions: o.functions, registeredEventListeners: [] } };
                        (n.thisContext.registerEventListener = t._registerEventListener.bind(n.thisContext)),
                            t._instances.push(n),
                            e(i).data("components") &&
                                e(i)
                                    .data("components")
                                    .split(",")
                                    .forEach((t) => {
                                        e(document).trigger("cc:component:load", [t, i]);
                                    }),
                            t._callSectionWith(o, "onSectionLoad", i, n.thisContext),
                            t._callSectionWith(o, "afterSectionLoadCallback", i, n.thisContext),
                            o.onSectionSelect &&
                                n.$shopifySectionContainer.on("shopify:section:select", function (e) {
                                    t._callSectionWith(o, "onSectionSelect", e.target, n.thisContext);
                                }),
                            o.onSectionDeselect &&
                                n.$shopifySectionContainer.on("shopify:section:deselect", function (e) {
                                    t._callSectionWith(o, "onSectionDeselect", e.target, n.thisContext);
                                }),
                            o.onBlockSelect &&
                                e(i).on("shopify:block:select", function (e) {
                                    t._callSectionWith(o, "onBlockSelect", e.target, n.thisContext);
                                }),
                            o.onBlockDeselect &&
                                e(i).on("shopify:block:deselect", function (e) {
                                    t._callSectionWith(o, "onBlockDeselect", e.target, n.thisContext);
                                });
                    }
                }),
                (t.sectionUnload = function (i) {
                    for (var a = t._sectionForTarget(i), o = -1, n = 0; n < t._instances.length; n++) t._instances[n].target == i && (o = n);
                    if (o > -1) {
                        var s = t._instances[o];
                        e(i).off("shopify:block:select shopify:block:deselect"),
                            s.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect"),
                            t._callSectionWith(s.section, "onSectionUnload", i, s.thisContext),
                            t._unloadRegisteredEventListeners(s.thisContext.registeredEventListeners),
                            t._callSectionWith(a, "afterSectionUnloadCallback", i, s.thisContext),
                            t._instances.splice(o),
                            e(i).data("components") &&
                                e(i)
                                    .data("components")
                                    .split(",")
                                    .forEach((t) => {
                                        e(document).trigger("cc:component:unload", [t, i]);
                                    });
                    } else
                        for (var n = 0; n < t._deferredSectionTargets.length; n++)
                            if (t._deferredSectionTargets[n].target == i) {
                                t._deferredSectionTargets[n].splice(n, 1);
                                break;
                            }
                }),
                (t.sectionReorder = function (e) {
                    for (var i = -1, a = 0; a < t._instances.length; a++) t._instances[a].target == e && (i = a);
                    if (i > -1) {
                        var o = t._instances[i];
                        t._callSectionWith(o.section, "onSectionReorder", e, o.thisContext);
                    }
                }),
                (t._registerEventListener = function (e, t, i) {
                    e.addEventListener(t, i), this.registeredEventListeners.push({ element: e, eventType: t, callback: i });
                }),
                (t._unloadRegisteredEventListeners = function (e) {
                    e.forEach((e) => {
                        e.element.removeEventListener(e.eventType, e.callback);
                    });
                }),
                (t._callSectionWith = function (e, t, i, a) {
                    if ("function" == typeof e[t])
                        try {
                            a ? e[t].bind(a)(i) : e[t](i);
                        } catch (o) {
                            var n = i.dataset.sectionType;
                            console.warn("Theme warning: '".concat(t, "' failed for section '").concat(n, "'")), console.debug(i, o);
                        }
                }),
                (t._themeSectionTargetFromShopifySectionTarget = function (t) {
                    var i = e("[data-section-type]:first", t);
                    return i.length > 0 && i[0];
                }),
                (t._sectionForTarget = function (i) {
                    for (var a = e(i).attr("data-section-type"), o = 0; o < t._sections.length; o++) if (t._sections[o].type == a) return t._sections[o];
                    return !1;
                }),
                (t._sectionAlreadyRegistered = function (e) {
                    for (var i = 0; i < t._sections.length; i++) if (t._sections[i].type == e) return !0;
                    return !1;
                });
        })()),
        (theme.Disclosure = (function () {
            var t = { disclosureList: "[data-disclosure-list]", disclosureToggle: "[data-disclosure-toggle]", disclosureInput: "[data-disclosure-input]", disclosureOptions: "[data-disclosure-option]" },
                i = { listVisible: "disclosure-list--visible" };
            function a(e) {
                (this.$container = e), (this.cache = {}), this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut();
            }
            return (
                (a.prototype = e.extend({}, a.prototype, {
                    _cacheSelectors: function e() {
                        this.cache = {
                            $disclosureList: this.$container.find(t.disclosureList),
                            $disclosureToggle: this.$container.find(t.disclosureToggle),
                            $disclosureInput: this.$container.find(t.disclosureInput),
                            $disclosureOptions: this.$container.find(t.disclosureOptions),
                        };
                    },
                    _connectToggle: function t() {
                        this.cache.$disclosureToggle.on(
                            "click",
                            function (t) {
                                var a = "true" === e(t.currentTarget).attr("aria-expanded");
                                e(t.currentTarget).attr("aria-expanded", !a), this.cache.$disclosureList.toggleClass(i.listVisible);
                            }.bind(this)
                        );
                    },
                    _connectOptions: function t() {
                        this.cache.$disclosureOptions.on(
                            "click",
                            function (t) {
                                t.preventDefault(), this._submitForm(e(t.currentTarget).data("value"));
                            }.bind(this)
                        );
                    },
                    _onFocusOut: function t() {
                        this.cache.$disclosureToggle.on(
                            "focusout",
                            function (e) {
                                0 === this.$container.has(e.relatedTarget).length && this._hideList();
                            }.bind(this)
                        ),
                            this.cache.$disclosureList.on(
                                "focusout",
                                function (t) {
                                    var a = e(t.currentTarget).has(t.relatedTarget).length > 0;
                                    this.cache.$disclosureList.hasClass(i.listVisible) && !a && this._hideList();
                                }.bind(this)
                            ),
                            this.$container.on(
                                "keyup",
                                function (e) {
                                    27 === e.which && (this._hideList(), this.cache.$disclosureToggle.focus());
                                }.bind(this)
                            ),
                            (this.bodyOnClick = function (e) {
                                var t = this.$container.has(e.target).length > 0;
                                this.cache.$disclosureList.hasClass(i.listVisible) && !t && this._hideList();
                            }.bind(this)),
                            e("body").on("click", this.bodyOnClick);
                    },
                    _submitForm: function e(t) {
                        this.cache.$disclosureInput.val(t), this.$container.parents("form").submit();
                    },
                    _hideList: function e() {
                        this.cache.$disclosureList.removeClass(i.listVisible), this.cache.$disclosureToggle.attr("aria-expanded", !1);
                    },
                    unload: function t() {
                        e("body").off("click", this.bodyOnClick), this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off();
                    },
                })),
                a
            );
        })()),
        (theme.showQuickPopup = function (t, i) {
            var a = e('<div class="simple-popup"/>'),
                o = i.offset(),
                n = i[0].getBoundingClientRect().left;
            a.html(t).css({ left: o.left, top: o.top }).hide(), e("body").append(a);
            var s = -(a.outerWidth() - i.outerWidth()) / 2;
            n + s < 0 && (s -= n + s - 2),
                a.css({ marginTop: -a.outerHeight() - 10, marginLeft: s }),
                a
                    .fadeIn(200)
                    .delay(3500)
                    .fadeOut(400, function () {
                        e(this).remove();
                    });
        }),
        (theme.scriptsLoaded = {}),
        (theme.loadScriptOnce = function (e, t, i, a) {
            if (void 0 === theme.scriptsLoaded[e]) {
                theme.scriptsLoaded[e] = [];
                var o = document.createElement("script");
                (o.src = e),
                    (a || i) && (o.async = !1),
                    i && i(),
                    "function" == typeof t &&
                        (theme.scriptsLoaded[e].push(t),
                        o.readyState
                            ? (o.onreadystatechange = function () {
                                  if ("loaded" == o.readyState || "complete" == o.readyState) {
                                      o.onreadystatechange = null;
                                      for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                                      theme.scriptsLoaded[this] = !0;
                                  }
                              }.bind(e))
                            : (o.onload = function () {
                                  for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                                  theme.scriptsLoaded[this] = !0;
                              }.bind(e)));
                var n = document.getElementsByTagName("script")[0];
                return n.parentNode.insertBefore(o, n), !0;
            }
            if ("object" != typeof theme.scriptsLoaded[e] || "function" != typeof t) return "function" == typeof t && t(), !1;
            theme.scriptsLoaded[e].push(t);
        }),
        (theme.loadStyleOnce = function (e) {
            var t = e.replace(/^https?:/, "");
            if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
                var i = document.createElement("link");
                (i.href = t), (i.rel = "stylesheet"), (i.type = "text/css");
                var a = document.getElementsByTagName("link")[0];
                a.parentNode.insertBefore(i, a);
            }
        }),
        (e.fn.clickyBoxes = function (t) {
            if ("destroy" != t)
                return e(this)
                    .filter("select:not(.clickybox-replaced)")
                    .addClass("clickybox-replaced")
                    .each(function () {
                        var t,
                            i = i || e(this).attr("id"),
                            a = e('<ul class="clickyboxes"/>')
                                .attr("id", "clickyboxes-" + i)
                                .data("select", e(this))
                                .insertAfter(this);
                        (t = e(this).is("[id]") ? e('label[for="' + e(this).attr("id") + '"]') : e(this).siblings("label")).length > 0 &&
                            a.addClass(
                                "options-" +
                                    removeDiacritics(t.text())
                                        .toLowerCase()
                                        .replace(/'/g, "")
                                        .replace(/[^a-z0-9]+/g, "-")
                                        .replace(/-+/g, "-")
                                        .replace(/-*$/, "")
                            ),
                            e(this)
                                .find("option")
                                .each(function () {
                                    e("<li/>")
                                        .appendTo(a)
                                        .append(
                                            e('<a href="#"/>')
                                                .attr("data-value", e(this).val())
                                                .html(e(this).html())
                                                .addClass(
                                                    "opt--" +
                                                        removeDiacritics(e(this).text())
                                                            .toLowerCase()
                                                            .replace(/'/g, "")
                                                            .replace(/[^a-z0-9]+/g, "-")
                                                            .replace(/-+/g, "-")
                                                            .replace(/-*$/, "")
                                                )
                                        );
                                }),
                            e(this)
                                .hide()
                                .addClass("replaced")
                                .on("change.clickyboxes keyup.clickyboxes", function () {
                                    var t = e(this).val();
                                    a.find("a")
                                        .removeClass("active")
                                        .filter(function () {
                                            return e(this).attr("data-value") == t;
                                        })
                                        .addClass("active");
                                })
                                .trigger("keyup"),
                            a.on("click.clickyboxes", "a", function () {
                                if (!e(this).hasClass("active")) {
                                    var t = e(this).closest(".clickyboxes");
                                    t.data("select").val(e(this).data("value")).trigger("change"), t.trigger("change");
                                }
                                return !1;
                            });
                    });
            e(this).off(".clickyboxes"), e(this).next(".clickyboxes").off(".clickyboxes");
        }),
        (e.fn.selectReplace = function (t) {
            if ("destroy" != t)
                return e(this)
                    .filter("select:not(.replaced, .noreplace)")
                    .addClass("replaced")
                    .each(function () {
                        var t = e(this).find("option"),
                            i = t.filter(":selected").length > 0 ? t.filter(":selected").text() : t.first().text();
                        e(this)
                            .wrap('<div class="pretty-select">')
                            .parent()
                            .addClass("id-" + e(this).attr("id"))
                            .append(
                                '<span class="text"><span class="value">' +
                                    i +
                                    '</span></span><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 12.75L15 18.75L9 12.75" stroke="#154380" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                            )
                            .toggleClass("plaintext", e(this).hasClass("plaintext"));
                    })
                    .on("change.selectreplace keyup.selectreplace", function () {
                        e(this).siblings(".text").find(".value").html(e(this).find(":selected").html());
                    });
            e(this).off(".selectreplace");
        }),
        (theme.debounce = function (e) {
            var t,
                i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 700,
                a = arguments.length > 2 ? arguments[2] : void 0;
            return function () {
                var o = this,
                    n = arguments,
                    s = function i() {
                        (t = null), a || e.apply(o, n);
                    },
                    r = a && !t;
                clearTimeout(t), (t = setTimeout(s, i)), r && e.apply(o, n);
            };
        }),
        (s = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
        (c = 200),
        window.addEventListener(
            "scroll",
            ((r = function () {
                window.dispatchEvent(s);
            }),
            (l = -1),
            (d = !1),
            function () {
                clearTimeout(l),
                    (l = setTimeout(r, c)),
                    d ||
                        (r.call(),
                        (d = !0),
                        setTimeout(function () {
                            d = !1;
                        }, c));
            })
        );
    class p {
        constructor(e, t) {
            (this.$container = e), (this.namespace = t), (this.cssClasses = { visible: "cc-popup--visible", bodyNoScroll: "cc-popup-no-scroll", bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right" });
        }
        open(t) {
            if (this.$container.data("freeze-scroll")) {
                e("body").addClass(this.cssClasses.bodyNoScroll);
                var i = document.createElement("div");
                (i.className = "popup-scrollbar-measure"), document.body.appendChild(i);
                var a = i.getBoundingClientRect().width - i.clientWidth;
                document.body.removeChild(i),
                    a > 0 &&
                        e("body")
                            .css("padding-right", a + "px")
                            .addClass(this.cssClasses.bodyNoScrollPadRight);
            }
            this.$container.addClass(this.cssClasses.visible),
                (this.previouslyActiveElement = document.activeElement),
                setTimeout(() => {
                    this.$container.find(".cc-popup-close")[0].focus();
                }, 500),
                e(window).on("keydown" + this.namespace, (e) => {
                    27 === e.keyCode && this.close();
                }),
                t && t();
        }
        close(t) {
            if ((this.$container.removeClass(this.cssClasses.visible), this.previouslyActiveElement && e(this.previouslyActiveElement).focus(), e(window).off("keydown" + this.namespace), this.$container.data("freeze-scroll"))) {
                var i = 500,
                    a = this.$container.find(".cc-popup-modal");
                a.length && (i = parseFloat(getComputedStyle(a[0]).transitionDuration)) && i > 0 && (i *= 1e3),
                    setTimeout(() => {
                        e("body").removeClass(this.cssClasses.bodyNoScroll).removeClass(this.cssClasses.bodyNoScrollPadRight).css("padding-right", "0");
                    }, i);
            }
            t && t();
        }
    }
    (() => {
        (theme.initAnimateOnScroll = function () {
            if (document.body.classList.contains("cc-animate-enabled") && window.innerWidth >= 768) {
                var e = void 0 !== document.body.dataset.ccAnimateTimeout ? document.body.dataset.ccAnimateTimeout : 200;
                if ("IntersectionObserver" in window) {
                    var t = new IntersectionObserver((t, i) => {
                        t.forEach((t) => {
                            t.isIntersecting &&
                                !t.target.classList.contains("cc-animate-complete") &&
                                (setTimeout(() => {
                                    t.target.classList.add("-in", "cc-animate-complete");
                                }, e),
                                setTimeout(() => {
                                    t.target.classList.remove("data-cc-animate"), (t.target.style.transitionDuration = null), (t.target.style.transitionDelay = null);
                                }, 5e3),
                                i.unobserve(t.target));
                        });
                    });
                    document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)").forEach((e) => {
                        e.dataset.ccAnimateDelay && (e.style.transitionDelay = e.dataset.ccAnimateDelay),
                            e.dataset.ccAnimateDuration && (e.style.transitionDuration = e.dataset.ccAnimateDuration),
                            e.dataset.ccAnimate && e.classList.add(e.dataset.ccAnimate),
                            e.classList.add("cc-animate-init"),
                            t.observe(e);
                    });
                } else for (var i = document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)"), a = 0; a < i.length; a++) i[a].classList.add("-in", "cc-animate-complete");
            }
        }),
            theme.initAnimateOnScroll(),
            document.addEventListener("shopify:section:load", () => {
                setTimeout(theme.initAnimateOnScroll, 100);
            });
        try {
            window.matchMedia("(min-width: 768px)").addEventListener("change", (e) => {
                e.matches && setTimeout(theme.initAnimateOnScroll, 100);
            });
        } catch (e) {}
    })();
    class f {
        constructor(e) {
            (this.container = e),
                (this.selectors = {
                    inputMin: ".cc-price-range__input--min",
                    inputMax: ".cc-price-range__input--max",
                    control: ".cc-price-range__control",
                    controlMin: ".cc-price-range__control--min",
                    controlMax: ".cc-price-range__control--max",
                    bar: ".cc-price-range__bar",
                    activeBar: ".cc-price-range__bar-active",
                }),
                (this.controls = {
                    min: { barControl: e.querySelector(this.selectors.controlMin), input: e.querySelector(this.selectors.inputMin) },
                    max: { barControl: e.querySelector(this.selectors.controlMax), input: e.querySelector(this.selectors.inputMax) },
                }),
                (this.controls.min.value = parseInt("" === this.controls.min.input.value ? this.controls.min.input.placeholder : this.controls.min.input.value)),
                (this.controls.max.value = parseInt("" === this.controls.max.input.value ? this.controls.max.input.placeholder : this.controls.max.input.value)),
                (this.valueMin = this.controls.min.input.min),
                (this.valueMax = this.controls.min.input.max),
                (this.valueRange = this.valueMax - this.valueMin),
                [this.controls.min, this.controls.max].forEach((e) => {
                    e.barControl.setAttribute("aria-valuemin", this.valueMin), e.barControl.setAttribute("aria-valuemax", this.valueMax), e.barControl.setAttribute("tabindex", 0);
                }),
                this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value),
                this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value),
                (this.bar = e.querySelector(this.selectors.bar)),
                (this.activeBar = e.querySelector(this.selectors.activeBar)),
                (this.inDrag = !1),
                (this.rtl = document.querySelector("html[dir=rtl]")),
                this.bindEvents(),
                this.render();
        }
        getPxToValueRatio() {
            var e = this.bar.clientWidth / (this.valueMax - this.valueMin);
            return this.rtl ? -e : e;
        }
        getPcToValueRatio() {
            return 100 / (this.valueMax - this.valueMin);
        }
        setActiveControlValue(e) {
            isNaN(parseInt(e)) ||
                (this.activeControl === this.controls.min
                    ? ("" === e && (e = this.valueMin), (e = Math.min((e = Math.max(this.valueMin, e)), this.controls.max.value)))
                    : ("" === e && (e = this.valueMax), (e = Math.max((e = Math.min(this.valueMax, e)), this.controls.min.value))),
                (this.activeControl.value = Math.round(e)),
                this.activeControl.input.value != this.activeControl.value &&
                    (this.activeControl.value == this.activeControl.input.placeholder ? (this.activeControl.input.value = "") : (this.activeControl.input.value = this.activeControl.value),
                    this.activeControl.input.dispatchEvent(new CustomEvent("change", { bubbles: !0, cancelable: !1, detail: { sender: "theme:component:price_range" } }))),
                this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value));
        }
        render() {
            this.drawControl(this.controls.min), this.drawControl(this.controls.max), this.drawActiveBar();
        }
        drawControl(e) {
            var t = (e.value - this.valueMin) * this.getPcToValueRatio() + "%";
            this.rtl ? (e.barControl.style.right = t) : (e.barControl.style.left = t);
        }
        drawActiveBar() {
            var e = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + "%",
                t = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + "%";
            this.rtl ? ((this.activeBar.style.left = t), (this.activeBar.style.right = e)) : ((this.activeBar.style.left = e), (this.activeBar.style.right = t));
        }
        handleControlTouchStart(e) {
            e.preventDefault(),
                this.startDrag(e.target, e.touches[0].clientX),
                (this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this)),
                (this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this)),
                window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
                window.addEventListener("touchend", this.boundControlTouchEndEvent);
        }
        handleControlTouchMove(e) {
            this.moveDrag(e.touches[0].clientX);
        }
        handleControlTouchEnd(e) {
            e.preventDefault(), window.removeEventListener("touchmove", this.boundControlTouchMoveEvent), window.removeEventListener("touchend", this.boundControlTouchEndEvent), this.stopDrag();
        }
        handleControlMouseDown(e) {
            e.preventDefault(),
                this.startDrag(e.target, e.clientX),
                (this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this)),
                (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
                window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
                window.addEventListener("mouseup", this.boundControlMouseUpEvent);
        }
        handleControlMouseMove(e) {
            this.moveDrag(e.clientX);
        }
        handleControlMouseUp(e) {
            e.preventDefault(), window.removeEventListener("mousemove", this.boundControlMouseMoveEvent), window.removeEventListener("mouseup", this.boundControlMouseUpEvent), this.stopDrag();
        }
        startDrag(e, t) {
            this.controls.min.barControl === e ? (this.activeControl = this.controls.min) : (this.activeControl = this.controls.max), (this.dragStartX = t), (this.dragStartValue = this.activeControl.value), (this.inDrag = !0);
        }
        moveDrag(e) {
            if (this.inDrag) {
                var t = this.dragStartValue + (e - this.dragStartX) / this.getPxToValueRatio();
                this.setActiveControlValue(t), this.render();
            }
        }
        stopDrag() {
            this.inDrag = !1;
        }
        handleControlKeyDown(e) {
            "ArrowRight" === e.key ? this.incrementControlFromKeypress(e.target, 10) : "ArrowLeft" === e.key && this.incrementControlFromKeypress(e.target, -10);
        }
        incrementControlFromKeypress(e, t) {
            this.controls.min.barControl === e ? (this.activeControl = this.controls.min) : (this.activeControl = this.controls.max), this.setActiveControlValue(this.activeControl.value + t / this.getPxToValueRatio()), this.render();
        }
        handleInputChange(e) {
            (e.target.value = e.target.value.replace(/\D/g, "")),
                (e.detail && "theme:component:price_range" == e.detail.sender) ||
                    (this.controls.min.input === e.target ? (this.activeControl = this.controls.min) : (this.activeControl = this.controls.max), this.setActiveControlValue(e.target.value), this.render());
        }
        handleInputKeyup(e) {
            setTimeout(
                function () {
                    this.value = this.value.replace(/\D/g, "");
                }.bind(e.target),
                10
            );
        }
        bindEvents() {
            [this.controls.min, this.controls.max].forEach((e) => {
                e.barControl.addEventListener("touchstart", this.handleControlTouchStart.bind(this)),
                    e.barControl.addEventListener("mousedown", this.handleControlMouseDown.bind(this)),
                    e.barControl.addEventListener("keydown", this.handleControlKeyDown.bind(this)),
                    e.input.addEventListener("change", this.handleInputChange.bind(this)),
                    e.input.addEventListener("keyup", this.handleInputKeyup.bind(this));
            });
        }
        destroy() {}
    }
    new (class e extends h {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "price-range",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e);
            super(e, t);
        }
        init(e) {
            super.init(e), this.registerInstance(e, new f(e));
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e);
        }
    })();
    class m {
        constructor(e) {
            (this.accordion = e),
                (this.itemClass = ".cc-accordion-item"),
                (this.titleClass = ".cc-accordion-item__title"),
                (this.panelClass = ".cc-accordion-item__panel"),
                (this.allowMultiOpen = "true" === this.accordion.dataset.allowMultiOpen),
                this.allowMultiOpen || (this.activeItem = this.accordion.querySelector("".concat(this.itemClass, "[open]"))),
                this.bindEvents();
        }
        static addPanelHeight(e) {
            e.style.height = "".concat(e.scrollHeight, "px");
        }
        static removePanelHeight(e) {
            e.getAttribute("style"), e.removeAttribute("style");
        }
        open(e, t) {
            if (
                ((t.style.height = "0"),
                (e.open = !0),
                m.addPanelHeight(t),
                setTimeout(() => {
                    e.classList.add("is-open");
                }, 10),
                !this.allowMultiOpen)
            ) {
                if (this.activeItem && this.activeItem !== e) {
                    var i = this.activeItem.querySelector(this.panelClass);
                    this.close(this.activeItem, i);
                }
                this.activeItem = e;
            }
        }
        close(e, t) {
            m.addPanelHeight(t),
                e.classList.remove("is-open"),
                e.classList.add("is-closing"),
                this.activeItem === e && (this.activeItem = null),
                setTimeout(() => {
                    t.style.height = "0";
                }, 10);
        }
        handleClick(e) {
            var t = e.target.closest(this.titleClass);
            if (t) {
                e.preventDefault();
                var i = t.parentNode,
                    a = t.nextElementSibling;
                i.open ? this.close(i, a) : this.open(i, a);
            }
        }
        handleTransition(e) {
            if (e.target.matches(this.panelClass)) {
                var t = e.target,
                    i = t.parentNode;
                i.classList.contains("is-closing") && (i.classList.remove("is-closing"), (i.open = !1)), m.removePanelHeight(t);
            }
        }
        bindEvents() {
            (this.clickHandler = this.handleClick.bind(this)),
                (this.transitionHandler = this.handleTransition.bind(this)),
                this.accordion.addEventListener("click", this.clickHandler),
                this.accordion.addEventListener("transitionend", this.transitionHandler);
        }
        destroy() {
            this.accordion.removeEventListener("click", this.clickHandler), this.accordion.removeEventListener("transitionend", this.transitionHandler);
        }
    }
    new (class e extends h {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "accordion",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e);
            super(e, t);
        }
        init(e) {
            super.init(e), this.registerInstance(e, new m(e));
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e);
        }
    })(),
        (theme.VideoManager = new (function () {
            var t = this;
            (t._permitPlayback = function (t) {
                return !(e(t).hasClass("video-container--background") && 768 > e(window).outerWidth());
            }),
                (t.youtubeVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)' }),
                (t.youtubeApiReady = function () {
                    (t.youtubeVars.apiReady = !0), t._loadYoutubeVideos();
                }),
                (t._loadYoutubeVideos = function (i) {
                    e(t.youtubeVars.toProcessSelector, i).length &&
                        (t.youtubeVars.apiReady
                            ? e(t.youtubeVars.toProcessSelector, i).each(function () {
                                  if (t._permitPlayback(e(this))) {
                                      e(this).addClass("video--init"), t.youtubeVars.incrementor++;
                                      var i = "theme-yt-video-" + t.youtubeVars.incrementor;
                                      e(this).data("video-container-id", i);
                                      var a = e('<div class="video-container__video-element">').attr("id", i).appendTo(e(".video-container__video", this)),
                                          o = e(this).data("video-autoplay"),
                                          n = e(this).data("video-loop"),
                                          s = new YT.Player(i, {
                                              height: "360",
                                              width: "640",
                                              videoId: e(this).data("video-id"),
                                              playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, loop: n ? 1 : 0, playlist: e(this).data("video-id"), rel: 0, showinfo: 0 },
                                              events: {
                                                  onReady: t._onYoutubePlayerReady.bind({ autoplay: o, loop: n, $container: e(this) }),
                                                  onStateChange: t._onYoutubePlayerStateChange.bind({ autoplay: o, loop: n, $container: e(this) }),
                                              },
                                          });
                                      t.youtubeVars.videoData[i] = { id: i, container: this, videoElement: a, player: s };
                                  }
                              })
                            : theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
                }),
                (t._onYoutubePlayerReady = function (e) {
                    e.target.setPlaybackQuality("hd1080"), this.autoplay && (e.target.mute(), e.target.playVideo()), t._initBackgroundVideo(this.$container);
                }),
                (t._onYoutubePlayerStateChange = function (e) {
                    if (e.data == YT.PlayerState.PLAYING && (this.$container.addClass("video--play-started"), this.autoplay && e.target.mute(), this.loop)) {
                        var t = e.target.getDuration() - 1;
                        t > 2 &&
                            (function i() {
                                e.target.getCurrentTime() > t && e.target.seekTo(0), setTimeout(i, 250);
                            })();
                    }
                }),
                (t._unloadYoutubeVideos = function (i) {
                    for (var a in t.youtubeVars.videoData) {
                        var o = t.youtubeVars.videoData[a];
                        if (e(i).find(o.container).length) {
                            o.player.destroy(), delete t.youtubeVars.videoData[a];
                            return;
                        }
                    }
                }),
                (t.vimeoVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)' }),
                (t.vimeoApiReady = function () {
                    (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
                }),
                (t._loadVimeoVideos = function (i) {
                    e(t.vimeoVars.toProcessSelector, i).length &&
                        (t.vimeoVars.apiReady
                            ? e(t.vimeoVars.toProcessSelector, i).each(function () {
                                  if (t._permitPlayback(e(this))) {
                                      e(this).addClass("video--init"), t.vimeoVars.incrementor++;
                                      var i = e(this),
                                          a = "theme-vi-video-" + t.vimeoVars.incrementor;
                                      e(this).data("video-container-id", a);
                                      var o = e('<div class="video-container__video-element">').attr("id", a).appendTo(e(".video-container__video", this)),
                                          n = !!e(this).data("video-autoplay"),
                                          s = new Vimeo.Player(a, { url: e(this).data("video-url"), width: 640, loop: e(this).data("video-autoplay"), autoplay: n, muted: i.hasClass("video-container--background") || n });
                                      s.on(
                                          "playing",
                                          function () {
                                              e(this).addClass("video--play-started");
                                          }.bind(this)
                                      ),
                                          s.ready().then(function () {
                                              if ((n && (s.setVolume(0), s.play()), s.element && s.element.width && s.element.height)) {
                                                  var e = parseInt(s.element.height) / parseInt(s.element.width);
                                                  i.find(".video-container__video").css("padding-bottom", 100 * e + "%");
                                              }
                                              t._initBackgroundVideo(i);
                                          }),
                                          (t.vimeoVars.videoData[a] = { id: a, container: this, videoElement: o, player: s, autoPlay: n });
                                  }
                              })
                            : window.define
                            ? theme.loadScriptOnce(
                                  "https://player.vimeo.com/api/player.js",
                                  function () {
                                      (t.vimeoVars.apiReady = !0), t._loadVimeoVideos(), (window.define = window.tempDefine);
                                  },
                                  function () {
                                      (window.tempDefine = window.define), (window.define = null);
                                  }
                              )
                            : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                                  (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
                              }));
                }),
                (t._unloadVimeoVideos = function (i) {
                    for (var a in t.vimeoVars.videoData) {
                        var o = t.vimeoVars.videoData[a];
                        if (e(i).find(o.container).length) {
                            o.player.unload(), delete t.vimeoVars.videoData[a];
                            return;
                        }
                    }
                }),
                (t._loadThirdPartyApis = function (i) {
                    t._permitPlayback(e(".video-container", i)) && (t._loadYoutubeVideos(i), t._loadVimeoVideos(i));
                }),
                (t.mp4Vars = { incrementor: 0, videoData: {}, toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)' }),
                (t._loadMp4Videos = function (i) {
                    e(t.mp4Vars.toProcessSelector, i).length &&
                        e(t.mp4Vars.toProcessSelector, i)
                            .addClass("video--init")
                            .each(function () {
                                t.mp4Vars.incrementor++, e(this);
                                var i = "theme-mp-video-" + t.mp4Vars.incrementor;
                                e(this).data("video-container-id", i);
                                var a = e('<div class="video-container__video-element">').attr("id", i).appendTo(e(".video-container__video", this)),
                                    o = e("<video playsinline>");
                                e(this).data("video-loop") && o.attr("loop", "loop"),
                                    e(this).hasClass("video-container--background") || o.attr("controls", "controls"),
                                    e(this).data("video-autoplay") &&
                                        (o.attr({ autoplay: "autoplay", muted: "muted" }),
                                        (o[0].muted = !0),
                                        o.one("loadeddata", function () {
                                            this.play();
                                        })),
                                    o.on(
                                        "playing",
                                        function () {
                                            e(this).addClass("video--play-started");
                                        }.bind(this)
                                    ),
                                    o.attr("src", e(this).data("video-url")).appendTo(a),
                                    (t.mp4Vars.videoData[i] = { element: o[0] });
                            });
                }),
                (t._unloadMp4Videos = function (e) {}),
                (t._initBackgroundVideo = function (t) {
                    if (t.hasClass("video-container--background") && t.find(".video-container__video iframe").length) {
                        function i() {
                            var t = e(".video-container__media", this),
                                i = t.length ? t : this,
                                a = i.width(),
                                o = i.height(),
                                n = e(".video-container__video iframe", this),
                                s = n.attr("width") / n.attr("height"),
                                r = e(".video-container__video", this);
                            if (a / o > s) {
                                var c = a / s + 150;
                                r.css({ marginTop: (o - c) / 2 - 75, marginInlineStart: "", height: c + 150, width: "" });
                            } else {
                                var l = a * s + 150 * s;
                                r.css({ marginTop: -75, marginInlineStart: (a - l) / 2, height: o + 150, width: l });
                            }
                        }
                        i.bind(t)(), e(window).on("debouncedresize." + t.data("video-container-id"), i.bind(t));
                    }
                }),
                (this.onSectionLoad = function (i) {
                    e(".video-container[data-video-url]:not([data-video-type])").each(function () {
                        var t = e(this).data("video-url");
                        t.indexOf(".mp4") > -1 && e(this).attr("data-video-type", "mp4"),
                            t.indexOf("vimeo.com") > -1 && (e(this).attr("data-video-type", "vimeo"), e(this).attr("data-video-id", t.split("?")[0].split("/").pop())),
                            (t.indexOf("youtu.be") > -1 || t.indexOf("youtube.com") > -1) &&
                                (e(this).attr("data-video-type", "youtube"), t.indexOf("v=") > -1 ? e(this).attr("data-video-id", t.split("v=").pop().split("&")[0]) : e(this).attr("data-video-id", t.split("?")[0].split("/").pop()));
                    }),
                        t._loadThirdPartyApis(i),
                        t._loadMp4Videos(i),
                        e(window).on("debouncedresize.video-manager-resize", function () {
                            t._loadThirdPartyApis(i);
                        }),
                        e(".video-container__play", i).on("click", function (a) {
                            a.preventDefault();
                            var o = e(this).closest(".video-container");
                            o.addClass("video-container--playing"), e(i).trigger("cc:video:play");
                            var n = o.data("video-container-id");
                            0 === n.indexOf("theme-yt-video")
                                ? t.youtubeVars.videoData[n].player.playVideo()
                                : 0 === n.indexOf("theme-vi-video")
                                ? t.vimeoVars.videoData[n].player.play()
                                : 0 === n.indexOf("theme-mp-video") && t.mp4Vars.videoData[n].element.play();
                        }),
                        e(".video-container__stop", i).on("click", function (a) {
                            a.preventDefault();
                            var o = e(this).closest(".video-container");
                            o.removeClass("video-container--playing"), e(i).trigger("cc:video:stop");
                            var n = o.data("video-container-id");
                            0 === n.indexOf("theme-yt-video") ? t.youtubeVars.videoData[n].player.stopVideo() : (t.vimeoVars.videoData[n].player.pause(), t.vimeoVars.videoData[n].player.setCurrentTime(0));
                        });
                }),
                (this.onSectionUnload = function (i) {
                    e(".video-container__play, .video-container__stop", i).off("click"),
                        e(window).off("." + e(".video-container").data("video-container-id")),
                        e(window).off("debouncedresize.video-manager-resize"),
                        t._unloadYoutubeVideos(i),
                        t._unloadVimeoVideos(i),
                        t._unloadMp4Videos(i),
                        e(i).trigger("cc:video:stop");
                });
        })()),
        (window.onYouTubeIframeAPIReady = function () {
            theme.VideoManager.youtubeApiReady();
        }),
        u.sections.push({ name: "video", section: theme.VideoManager }),
        (theme.MapSection = new (function () {
            var t = this;
            (t.config = {
                zoom: 14,
                styles: {
                    default: [],
                    silver: [
                        { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                        { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                    ],
                    retro: [
                        { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] },
                        { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#c9b2a6" }] },
                        { featureType: "administrative.land_parcel", elementType: "geometry.stroke", stylers: [{ color: "#dcd2be" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#ae9e90" }] },
                        { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#93817c" }] },
                        { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#a5b076" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#447530" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#f5f1e6" }] },
                        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#fdfcf8" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#f8c967" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#e9bc62" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#e98d58" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry.stroke", stylers: [{ color: "#db8555" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#806b63" }] },
                        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "transit.line", elementType: "labels.text.fill", stylers: [{ color: "#8f7d77" }] },
                        { featureType: "transit.line", elementType: "labels.text.stroke", stylers: [{ color: "#ebe3cd" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#b9d3c2" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#92998d" }] },
                    ],
                    dark: [
                        { elementType: "geometry", stylers: [{ color: "#212121" }] },
                        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
                        { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }] },
                        { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
                        { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#181818" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ color: "#1b1b1b" }] },
                        { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
                        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] },
                    ],
                    night: [
                        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                        { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#263c3f" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#6b9a76" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
                        { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#746855" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#f3d19c" }] },
                        { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2f3948" }] },
                        { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
                        { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#17263c" }] },
                    ],
                    aubergine: [
                        { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#1a3646" }] },
                        { featureType: "administrative.country", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#64779e" }] },
                        { featureType: "administrative.province", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                        { featureType: "landscape.man_made", elementType: "geometry.stroke", stylers: [{ color: "#334e87" }] },
                        { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#023e58" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#283d6a" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#6f9ba5" }] },
                        { featureType: "poi", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#023e58" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#3C7680" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#304a7d" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                        { featureType: "road", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#2c6675" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#255763" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#b0d5ce" }] },
                        { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ color: "#023e58" }] },
                        { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                        { featureType: "transit", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "transit.line", elementType: "geometry.fill", stylers: [{ color: "#283d6a" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#3a4762" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#0e1626" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#4e6d70" }] },
                    ],
                },
            }),
                (t.apiStatus = null),
                (this.geolocate = function (t) {
                    var i = e.Deferred(),
                        a = new google.maps.Geocoder(),
                        o = t.data("address-setting");
                    return (
                        a.geocode({ address: o }, function (e, t) {
                            t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
                        }),
                        i
                    );
                }),
                (this.createMap = function (i) {
                    var a = e(".map-section__map-container", i);
                    return t
                        .geolocate(a)
                        .then(
                            function (o) {
                                var n = { zoom: t.config.zoom, styles: t.config.styles[e(i).data("map-style")], center: o[0].geometry.location, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0, zoomControl: !0 };
                                (t.map = new google.maps.Map(a[0], n)),
                                    (t.center = t.map.getCenter()),
                                    new google.maps.Marker({ map: t.map, position: t.center, clickable: !1 }),
                                    google.maps.event.addDomListener(window, "resize", function () {
                                        google.maps.event.trigger(t.map, "resize"), t.map.setCenter(t.center);
                                    });
                            }.bind(this)
                        )
                        .fail(function () {
                            var e;
                            switch (status) {
                                case "ZERO_RESULTS":
                                    e = theme.strings.addressNoResults;
                                    break;
                                case "OVER_QUERY_LIMIT":
                                    e = theme.strings.addressQueryLimit;
                                    break;
                                default:
                                    e = theme.strings.addressError;
                            }
                            if (Shopify.designMode) {
                                var t = a.parents(".map-section");
                                t.addClass("page-width map-section--load-error"), t.find(".map-section__wrapper").html('<div class="errors text-center">' + e + "</div>");
                            }
                        });
                }),
                (this.onSectionLoad = function (i) {
                    var a = e(i);
                    window.gm_authFailure = function () {
                        Shopify.designMode && (a.addClass("page-width map-section--load-error"), a.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"));
                    };
                    var o = a.data("api-key");
                    "string" == typeof o &&
                        "" !== o &&
                        theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + o, function () {
                            t.createMap(a);
                        });
                }),
                (this.onSectionUnload = function (e) {
                    void 0 !== window.google && void 0 !== google.maps && google.maps.event.clearListeners(t.map, "resize");
                });
        })()),
        u.sections.push({ name: "map", section: theme.MapSection }),
        (theme.Popup = new (function () {
            var t = "cc-theme-popup-dismissed";
            (this.onSectionLoad = function (i) {
                (this.namespace = theme.namespaceFromSection(i)), (this.$container = e(i)), (this.popup = new p(this.$container, this.namespace));
                var a = this.$container.data("dismiss-for-days"),
                    o = this.$container.data("delay-seconds"),
                    n = !0,
                    s = this.$container.data("test-mode"),
                    r = window.localStorage.getItem(t);
                r && (new Date().getTime() - r) / 864e5 < a && (n = !1),
                    this.$container.find(".cc-popup-form__response").length && ((n = !0), (o = 1), this.$container.find(".cc-popup-form__response--success").length && this.functions.popupSetAsDismissed.call(this)),
                    document.querySelector(".shopify-challenge__container") && (n = !1),
                    (n || s) &&
                        setTimeout(() => {
                            this.popup.open();
                        }, 1e3 * o),
                    this.$container.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", () => {
                        this.popup.close(() => {
                            this.functions.popupSetAsDismissed.call(this);
                        });
                    });
            }),
                (this.onSectionSelect = function () {
                    this.popup.open();
                }),
                (this.functions = {
                    popupSetAsDismissed: function e() {
                        window.localStorage.setItem(t, new Date().getTime());
                    },
                }),
                (this.onSectionUnload = function () {
                    this.$container.off(this.namespace);
                });
        })()),
        u.sections.push({ name: "newsletter-popup", section: theme.Popup }),
        (theme.StoreAvailability = function (t) {
            var i = "store-availability-loading",
                a = "cc-location";
            (this.onSectionLoad = function (t) {
                (this.namespace = theme.namespaceFromSection(t)),
                    (this.$container = e(t)),
                    (this.productId = this.$container.data("store-availability-container")),
                    (this.sectionUrl = this.$container.data("section-url")),
                    this.$modal,
                    this.$container.addClass("store-availability-initialized"),
                    (this.transitionDurationMS = 1e3 * parseFloat(getComputedStyle(t).transitionDuration)),
                    (this.removeFixedHeightTimeout = -1),
                    e(window).on("cc-variant-updated", (e, t) => {
                        let i = t.product;
                        t.variant, (LAST_PRODUCT_SELECTED = i);
                    }),
                    e(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), (e, t) => {
                        t.product.id === this.productId &&
                            this.functions.updateContent.bind(this)(t.variant ? t.variant.id : null, t.product.title, this.$container.data("has-only-default-variant"), t.variant && void 0 !== t.variant.available);
                    }),
                    this.$container.data("single-variant-id") &&
                        this.functions.updateContent.bind(this)(
                            this.$container.data("single-variant-id"),
                            this.$container.data("single-variant-product-title"),
                            this.$container.data("has-only-default-variant"),
                            this.$container.data("single-variant-product-available")
                        );
            }),
                (this.onSectionUnload = function () {
                    e(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId)), this.$container.off("click"), this.$modal && this.$modal.off("click");
                }),
                (this.functions = {
                    getUserLocation: function e() {
                        return new Promise((e, t) => {
                            var i;
                            sessionStorage[a] && (i = JSON.parse(sessionStorage[a])),
                                i
                                    ? e(i)
                                    : navigator.geolocation
                                    ? navigator.geolocation.getCurrentPosition(
                                          function (t) {
                                              var i = { latitude: t.coords.latitude, longitude: t.coords.longitude };
                                              fetch("/localization.json", { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(i) }), (sessionStorage[a] = JSON.stringify(i)), e(i);
                                          },
                                          function () {
                                              e(!1);
                                          },
                                          { maximumAge: 36e5, timeout: 5e3 }
                                      )
                                    : e(!1);
                        });
                    },
                    getAvailableStores: function t(i, a) {
                        return e.get(this.sectionUrl.replace("VARIANT_ID", i), a);
                    },
                    calculateDistance: function e(t, i, a) {
                        var o,
                            n = Math.PI / 180,
                            s = t.latitude * n,
                            r = t.longitude * n,
                            c = i.latitude * n,
                            l = Math.pow(Math.sin((s - c) / 2), 2) + Math.cos(s) * Math.cos(c) * Math.pow(Math.sin((r - i.longitude * n) / 2), 2);
                        return ("metric" === a ? 6378.14 : 3959) * (2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)));
                    },
                    updateLocationDistances: function t(i) {
                        var a = this.$modal.find("[data-unit-system]").data("unit-system"),
                            o = this;
                        this.$modal.find('[data-distance="false"]').each(function () {
                            var t = { latitude: parseFloat(e(this).data("latitude")), longitude: parseFloat(e(this).data("longitude")) };
                            if (t.latitude && t.longitude) {
                                var n = o.functions.calculateDistance(i, t, a).toFixed(1);
                                e(this).html(n),
                                    setTimeout(() => {
                                        e(this).closest(".store-availability-list__location__distance").addClass("-in");
                                    }, 0);
                            }
                            e(this).attr("data-distance", "true");
                        });
                    },
                    updateContent: function t(a, o, n, s) {
                        this.$container.off("click", "[data-store-availability-modal-open]"),
                            this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background"),
                            e(".store-availabilities-modal").remove(),
                            s
                                ? (this.$container.addClass(i), this.transitionDurationMS > 0 && this.$container.css("height", this.$container.outerHeight() + "px"))
                                : (this.$container.addClass(i), this.transitionDurationMS > 0 && this.$container.css("height", "0px")),
                            s &&
                                this.functions.getAvailableStores.call(this, a, (t) => {
                                    if (t.trim().length > 0 && !t.includes("NO_PICKUP")) {
                                        this.$container.html(t),
                                            this.$container.html(this.$container.children().first().html()),
                                            this.$container.find("[data-store-availability-modal-product-title]").html(o),
                                            n && this.$container.find(".store-availabilities-modal__variant-title").remove(),
                                            this.$container.find(".cc-popup").appendTo("body"),
                                            (this.$modal = e("body").find(".store-availabilities-modal"));
                                        var s = new p(this.$modal, this.namespace);
                                        if (
                                            (this.$container.on(
                                                "click",
                                                "[data-store-availability-modal-open]",
                                                () => (
                                                    s.open(),
                                                    this.functions.getUserLocation().then((t) => {
                                                        t &&
                                                            this.$modal.find('[data-distance="false"]').length &&
                                                            this.functions.getAvailableStores.call(this, a, (i) => {
                                                                this.$modal.find(".store-availabilities-list").html(e(i).find(".store-availabilities-list").html()), this.functions.updateLocationDistances.bind(this)(t);
                                                            });
                                                    }),
                                                    !1
                                                )
                                            ),
                                            this.$modal.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", () => {
                                                s.close();
                                            }),
                                            this.$container.removeClass(i),
                                            this.transitionDurationMS > 0)
                                        ) {
                                            var r = this.$container.find(".store-availability-container").outerHeight();
                                            this.$container.css("height", r > 0 ? r + "px" : ""),
                                                clearTimeout(this.removeFixedHeightTimeout),
                                                (this.removeFixedHeightTimeout = setTimeout(() => {
                                                    this.$container.css("height", "");
                                                }, this.transitionDurationMS));
                                        }
                                    }
                                });
                    },
                }),
                this.onSectionLoad(t);
        }),
        u.sections.push({ name: "store-availability", section: theme.StoreAvailability }),
        (theme.icons = {
            left:
                '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="{{ icon_class }}"><path d="M7.25 13L1.25 7L7.25 1" stroke="#154380" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            right:
                '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="{{ icon_class }}"><path d="M1.25 13L7.25 7L1.25 1" stroke="#154380" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            close:
                '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1L1 17" stroke="#154380" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 1L17 17" stroke="#154380" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><rect width="18" height="18" fill="white"/></defs></svg>',
            chevronLeft:
                '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="15" transform="matrix(1 1.74846e-07 1.74846e-07 -1 15 15)" fill="#154380"/><path d="M17.25 21L11.25 15L17.25 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            chevronRight:
                '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="15" transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 15 15)" fill="#154380"/><path d="M12.75 9L18.75 15L12.75 21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            tick:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>',
            arrowRight:
                '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 13L7.25 7L1.25 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        }),
        (theme.viewport = {
            isXs: () => 768 > e(window).outerWidth(),
            isSm: () => e(window).outerWidth() >= 768,
            isMd: () => e(window).outerWidth() >= 992,
            isLg: () => e(window).outerWidth() >= 1200,
            scrollTo: function t(i) {
                var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1,
                    o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3,
                    n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
                    s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                i && "string" == typeof i && (i = e(i)), s && (n += e("#toolbar").outerHeight()), -1 === a && i && i.length && (a = i.offset().top - n), e("html,body").animate({ scrollTop: a }, o);
            },
        }),
        (theme.browser = { isSafari: () => -1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome") }),
        (theme.device = {
            isTouch() {
                try {
                    return document.createEvent("TouchEvent"), !0;
                } catch (e) {
                    return !1;
                }
            },
        });
    try {
        theme.Shopify.features = JSON.parse(document.documentElement.querySelector("#shopify-features").textContent);
    } catch (v) {
        theme.Shopify.features = {};
    }
    if (((theme.productData = {}), !theme.imageLazyLoader)) {
        for (var g = document.querySelectorAll('img[loading="lazy"][data-lazy-src],[data-lazy-bg]'), y = 0; y < g.length; y++) {
            var b = g[y],
                $ = b.clientWidth ? b.clientWidth : 500,
                k = b.getAttribute("data-lazy-src");
            if (k) b.setAttribute("src", k.replace("{width}x", $ + "x"));
            else {
                var w = b.getAttribute("data-lazy-bg");
                w && (b.style.backgroundImage = "url(" + w.replace("{width}x", $ + "x") + ")");
            }
        }
        theme.imageLazyLoader = { loadLazyImage() {}, loadLazyImages() {} };
    }
    (theme.namespaceFromSection = function (t) {
        return [".", e(t).data("section-type"), e(t).data("section-id")].join("");
    }),
        (theme.initContentSlider = function (t, i) {
            var a = e(".slideshow .slide", t).length - 1,
                o = "instant" == e(this).data("transition") ? 0 : 1e3;
            e(this).data("transition-speed") && (o = e(this).data("transition-speed")),
                e(".slideshow", t).each(function () {
                    e(this)
                        .on("init", function () {
                            setTimeout(() => {
                                e(".slideshow", t)
                                    .find('img[loading="lazy"]')
                                    .each(function () {
                                        theme.imageLazyLoader.loadLazyImage(e(this)[0]), e(this).attr("loading", "auto");
                                    });
                            }, 5e3);
                        })
                        .slick({
                            autoplay: e(this).data("autoplay"),
                            fade: "slide" != e(this).data("transition"),
                            speed: o,
                            autoplaySpeed: 1e3 * e(this).data("autoplay-speed"),
                            arrows: "arrows" == e(this).data("navigation"),
                            dots: "dots" == e(this).data("navigation"),
                            infinite: !0,
                            useTransform: !0,
                            prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                            pauseOnHover: !1,
                            cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
                            lazyLoad: e(this).find("[data-lazy]").length > 0 ? "ondemand" : null,
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: {
                                        fade: "slide" != e(this).data("transition"),
                                        speed: "instant" == e(this).data("transition") ? 0 : 750,
                                        arrows: !0,
                                        dots: "none" != e(this).data("navigation"),
                                        lazyLoad: e(this).find("[data-lazy]").length > 0 ? "progressive" : null,
                                    },
                                },
                            ],
                        })
                        .on("beforeChange", function (t, i, o, n) {
                            var s = "left";
                            ((n < o && (o !== a || 0 !== n)) || (0 == o && n === a)) && (1 !== n || 0 !== o) && (s = "right"), e(this).addClass("direction-".concat(s));
                            var r = e(i.$slides.get(o));
                            r.addClass("-outgoing").addClass("-leaving"),
                                setTimeout(
                                    () => {
                                        e(this).removeClass("direction-left").removeClass("direction-right"), r.removeClass("-outgoing");
                                    },
                                    (o === a && n == n) || (0 === o && n === a) ? 600 : 100
                                ),
                                setTimeout(() => {
                                    r.removeClass("-leaving");
                                }, 1e3);
                        })
                        .on("afterChange", function (e, t, a) {
                            i && i(a);
                        });
                });
        }),
        (theme.uncontainImages = function (t) {
            if ((e(".reading-column [data-fullwidth]:not(.uncontain)", t).addClass("uncontain"), e(".reading-column .uncontain").length > 0)) {
                function i() {
                    var t = "rgb(255, 0, 1)" == e("#page-wrap-inner").css("border-color") ? e(window).width() : e(".container:visible:first").width();
                    e(".reading-column .uncontain").each(function () {
                        var i = e(this).closest("div:not(.uncontain), p:not(.uncontain)").width();
                        e(this).css({ width: t, marginLeft: -(t - i) / 2, maxWidth: "none" });
                    });
                }
                e(window).on("resize.wideimgs wideimgs.wideimgs", i).trigger("wideimgs"),
                    e(function () {
                        i();
                    });
            } else e(window).off(".wideimgs");
        }),
        (theme.formatMoney = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : theme.money_format_with_code_preference,
                i = theme.Shopify.formatMoney(e, t);
            return (
                theme.settings.superscriptDecimals &&
                    (t.includes("{{amount}}") || t.includes("{{ amount }}") || t.includes("{{amount_with_apostrophe_separator}}") || t.includes("{{ amount_with_apostrophe_separator }}")
                        ? ((i = i.replace(".", "<sup>")), theme.settings.currencyCodeEnabled && (i = i.replace(" ", "</sup> ")), (i += "</sup>"))
                        : (t.includes("{{amount_with_comma_separator}}") || t.includes("{{ amount_with_comma_separator }}")) &&
                          ((i = i.replace(",", "<sup>")), theme.settings.currencyCodeEnabled && (i = i.replace(" ", "</sup> ")), (i += "</sup>"))),
                i
            );
        }),
        (theme.utils = {
            getUrlParameter: function e(t) {
                var i = RegExp("[\\?&]" + (t = t.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")) + "=([^&#]*)").exec(location.search);
                return null === i ? "" : decodeURIComponent(i[1].replace(/\+/g, " "));
            },
            cookie: {
                create: function e(t, i, a) {
                    var o = "";
                    if (a) {
                        var n = new Date();
                        n.setTime(n.getTime() + 864e5 * a), (o = "; expires=" + n.toUTCString());
                    }
                    document.cookie = t + "=" + i + o + "; path=/";
                },
                read: function e(t) {
                    var i = t + "=";
                    try {
                        for (var a = document.cookie.split(";"), o = 0; o < a.length; o++) {
                            for (var n = a[o]; " " == n.charAt(0); ) n = n.substring(1, n.length);
                            if (0 == n.indexOf(i)) return n.substring(i.length, n.length);
                        }
                    } catch (s) {}
                    return null;
                },
                erase: function e(t) {
                    theme.utils.cookie.create(t, "", -1);
                },
                exists: function e(t) {
                    return void 0 !== theme.utils.cookie.read(t);
                },
            },
        }),
        (theme.OptionManager = new (function () {
            var t = this;
            (t._getVariantOptionElement = function (e, t) {
                return t.find('select[name="id"] option[value="' + e.id + '"]');
            }),
                (t.selectors = {
                    container: ".product-container",
                    gallery: ".product-gallery",
                    priceArea: ".product-price",
                    submitButton: ".product-form input[type=submit], .product-form button[type=submit]",
                    multiOption: ".option-selectors",
                }),
                (t.strings = {
                    priceNonExistent: theme.strings.priceNonExistent,
                    buttonDefault: theme.strings.buttonDefault,
                    buttonNoStock: theme.strings.buttonNoStock,
                    buttonNoVariant: theme.strings.buttonNoVariant,
                    unitPriceSeparator: theme.strings.unitPriceSeparator,
                    inventoryNotice: theme.strings.onlyXLeft,
                }),
                (t._getString = function (e, i) {
                    var a = t.strings[e];
                    return i && (a = a.replace("[PRICE]", '<span class="theme-money">' + theme.formatMoney(i.price) + "</span>")), a;
                }),
                (t.getProductData = function (e) {
                    var t = e.data("product-id"),
                        i = null;
                    if (!theme.productData[t]) {
                        var a = document.getElementById("ccProductJson-" + t);
                        a && (theme.productData[t] = JSON.parse(a.innerHTML));
                    }
                    return (i = theme.productData[t]) || console.warn("CC: Product data missing (id: " + e.data("product-id") + ")"), i;
                }),
                (t.getBaseUnit = function (e) {
                    return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                }),
                (t.addVariantUrlToHistory = function (e) {
                    if (e) {
                        var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                        window.history.replaceState({ path: t }, "", t);
                    }
                }),
                (t.updateWeight = function (e, i) {
                    var a = t._getVariantOptionElement(e, i).data("weight");
                    a ? i.find(".product-weight").removeClass("product-weight--no-weight").find(".product-weight__value").html(a) : i.find(".product-weight").addClass("product-weight--no-weight").find(".product-weight__value").empty();
                }),
                (t.updateSku = function (e, t) {
                    t.find(".sku .sku__value").html(e ? e.sku : ""), t.find(".sku").toggleClass("sku--no-sku", !e || !e.sku);
                }),
                (t.updateBarcode = function (e, t) {
                    t.find(".barcode .barcode__value").html(e ? e.barcode : ""), t.find(".barcode").toggleClass("barcode--no-barcode", !e || !e.barcode);
                }),
                (t.updateInventoryNotice = function (e, i) {
                    var a = t._getVariantOptionElement(e, i).data("inventory");
                    a
                        ? i.find(".product-inventory-notice").removeClass("product-inventory-notice--no-inventory").html(t._getString("inventoryNotice").replace("[[ quantity ]]", a))
                        : i.find(".product-inventory-notice").addClass("product-inventory-notice--no-inventory").empty();
                }),
                (t.updateInventoryLimit = function (e, i) {
                    var a = t._getVariantOptionElement(e, i).data("inventory");
                    a ? i.find("[data-limit]").attr("data-limit", a) : i.find("[data-limit]").attr("data-limit", "");
                }),
                (t.updateBackorder = function (e, i) {
                    var a = i.find(".backorder");
                    if (a.length) {
                        if (e && e.available) {
                            if (e.inventory_management && "out" == t._getVariantOptionElement(e, i).data("stock")) {
                                var o = t.getProductData(a.closest("form"));
                                a.find(".backorder__variant").html(o.title + (e.title.indexOf("Default") >= 0 ? "" : " - " + e.title)), a.removeClass("hidden");
                            } else a.addClass("hidden");
                        } else a.addClass("hidden");
                    }
                }),
                (t.updatePrice = function (i, a) {
                    var o = a.find(t.selectors.priceArea);
                    if ((o.removeClass("on-sale"), i)) {
                        var n = e("<div>");
                        if (
                            (e('<span class="current-price theme-money">').html(theme.formatMoney(i.price)).appendTo(n),
                            i.compare_at_price > i.price && (n.append(" "), e('<span class="was-price theme-money">').html(theme.formatMoney(i.compare_at_price)).appendTo(n), o.addClass("on-sale")),
                            i.unit_price_measurement)
                        ) {
                            var s = e('<div class="unit-price">').appendTo(n);
                            e('<span class="unit-price__price theme-money">').html(theme.formatMoney(i.unit_price, theme.money_format)).appendTo(s),
                                e('<span class="unit-price__separator">').html(t._getString("unitPriceSeparator")).appendTo(s),
                                e('<span class="unit-price__unit">').html(t.getBaseUnit(i)).appendTo(s);
                        }
                        o.html(n.html());
                    } else o.html(t._getString("priceNonExistent", i));
                }),
                (t._updateButtonText = function (i, a, o) {
                    i.each(function () {
                        var i;
                        !1 !== (i = t._getString("button" + a, o)) && (e(this).is("input") ? e(this).val(i) : e(this).html(i));
                    });
                }),
                (t.updateButtons = function (e, i) {
                    var a = i.find(t.selectors.submitButton),
                        o = i.find(t.selectors.submitButton + " .button-text");
                    e && !0 == e.available
                        ? a.removeAttr("disabled").attr("data-btn-type", "add-to-cart").removeClass("product-add--adding")
                        : (a.attr("disabled", "disabled").attr("data-btn-type", "unavailable"), e ? t._updateButtonText(o, "NoStock", e) : t._updateButtonText(o, "NoVariant", e));
                }),
                (t.updateContainerStatusClasses = function (e, i) {
                    i.toggleClass("variant-status--unavailable", !e.available), i.toggleClass("variant-status--backorder", e.available && e.inventory_management && "out" == t._getVariantOptionElement(e, i).data("stock"));
                }),
                (t.initProductOptions = function (i) {
                    e(i)
                        .not(".theme-init")
                        .addClass("theme-init")
                        .each(function () {
                            var i = e(this);
                            if (i.is("select")) {
                                var a = t.getProductData(i.closest("form"));
                                i.on("change.themeProductOptions firstrun.themeProductOptions", function (i) {
                                    if (!e(this).is("input[type=radio]:not(:checked)")) {
                                        var o = i.detail;
                                        if (!o && !1 !== o) for (var n = 0; n < a.variants.length; n++) a.variants[n].id == e(this).val() && (o = a.variants[n]);
                                        var s = e(this).closest(t.selectors.container);
                                        t.updatePrice(o, s),
                                            t.updateButtons(o, s),
                                            o && o.featured_media && s.find(t.selectors.gallery).trigger("variantImageSelected", o),
                                            t.updateBarcode(o, s),
                                            t.updateWeight(o, s),
                                            t.updateSku(o, s),
                                            t.updateInventoryNotice(o, s),
                                            t.updateBackorder(o, s),
                                            t.updateContainerStatusClasses(o, s),
                                            t.updateInventoryLimit(o, s),
                                            e(window).trigger("cc-variant-updated", { variant: o, product: a }),
                                            e(this).closest("form").data("enable-history-state") && "change" == i.type && t.addVariantUrlToHistory(o),
                                            s.find(".quickbuy-container").trigger("changedsize");
                                    }
                                }),
                                    i
                                        .closest(t.selectors.container)
                                        .find(t.selectors.multiOption)
                                        .on("change.themeProductOptions", "select", function () {
                                            var o = [];
                                            e(this)
                                                .closest(t.selectors.multiOption)
                                                .find("select")
                                                .each(function () {
                                                    o.push(e(this).val());
                                                });
                                            for (var n = !1, s = 0; s < a.variants.length; s++) {
                                                for (var r = a.variants[s], c = 0, l = 0; l < o.length; l++) r.options[l] == o[l] && c++;
                                                if (c == o.length) {
                                                    n = r;
                                                    break;
                                                }
                                            }
                                            n && i.val(n.id), i[0].dispatchEvent(new CustomEvent("change", { bubbles: !0, cancelable: !1, detail: n }));
                                        }),
                                    i.trigger("firstrun");
                            }
                            theme.applyAjaxToProductForm(i.closest("form"));
                        });
                }),
                (t.unloadProductOptions = function (i) {
                    e(i)
                        .removeClass("theme-init")
                        .each(function () {
                            e(this).trigger("unloading").off(".themeProductOptions"),
                                e(this).closest(t.selectors.container).find(t.selectors.multiOption).off(".themeProductOptions"),
                                theme.removeAjaxFromProductForm(e(this).closest("form"));
                        });
                });
        })()),
        (theme.loadCartNoteMonitor = function (t) {
            e('.cart-form [name="note"]', t).on("change.themeLoadCartNoteMonitor", function () {
                e.post(theme.routes.cart_url + "/update.js", { note: e(this).val() }, function (e) {}, "json");
            });
        }),
        (theme.unloadCartNoteMonitor = function (t) {
            e('.cart-form [name="note"]', t).off("change.themeLoadCartNoteMonitor");
        }),
        (theme.loadProductGrid = function (t) {
            e(window).trigger("normheights"),
                theme.loadInPlaceQuantityAdjustment(t),
                theme.applyAjaxToProductForm(e("form.product-form", t)),
                e(t).on("mouseenter.swatchHover", ".swatch-option[data-media-url]", function () {
                    var t = e(this).closest(".product-block").find(".image__primary .rimage__image");
                    t.attr("data-lazy-src", e(this).data("media-url")), theme.imageLazyLoader.loadLazyImage(t[0]);
                });
        }),
        (theme.unloadProductGrid = function (t) {
            theme.unloadInPlaceQuantityAdjustment(t), theme.removeAjaxFromProductForm(e("form.product-form", t)), e(t).off(".swatchHover");
        }),
        (theme.ProductMediaGallery = function (t) {
            var i,
                a = this,
                o = {},
                n = t.find(".view-in-space"),
                s = t.data("enable-zoom") && !theme.device.isTouch(),
                r = t.data("slideshow-mob-nav"),
                c = !1,
                l = !0;
            e(window).on("resize", function () {
                e(".thumbnails", t).width("100%").width(e(".thumbnails", t).width());
            });
            var d = e(".thumbnails", t)
                    .on("init reInit setPosition", function (t) {
                        var i = e(this).find(".slick-slide:last");
                        if (i.length > 0) {
                            var a = i.position().left + i.outerWidth(!0),
                                o = e(this).width();
                            e(this).toggleClass("slick-slider--all-visible", o > a);
                        }
                        setTimeout(function () {
                            e(t.target).find(".slick-slide").attr({ tabindex: "0", "aria-hidden": "false" });
                        });
                    })
                    .slick({
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: !1,
                        speed: 400,
                        prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                        nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                        responsive: [
                            { breakpoint: 1500, settings: { slidesToShow: 4, slidesToScroll: 3 } },
                            { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 3 } },
                            { breakpoint: 767, settings: { arrows: !0, slidesToShow: 4, slidesToScroll: 4 } },
                        ],
                    }),
                u = e(".product-slideshow", t)
                    .slick({
                        fade: !1,
                        speed: 500,
                        arrows: !0,
                        dots: !1,
                        infinite: !1,
                        useTransform: !0,
                        adaptiveHeight: !0,
                        prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                        nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                        cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
                        responsive: [{ breakpoint: 767, settings: { dots: "dots" === r, arrows: "arrows" === r } }],
                    })
                    .on("beforeChange", function (i, o, n, s) {
                        var r = e(o.$slides.get(s)),
                            l = e('.thumbnail[data-media-id="'.concat(r.data("media-id"), '"]'), t);
                        t.attr("data-full-image-width", l.data("full-image-width")),
                            l.addClass("active").siblings(".active").removeClass("active"),
                            !1 === c ? d.slick("slickGoTo", l.index()) : (c = !1),
                            t.attr("data-current-media-type", r.data("media-type")),
                            a.setCurrentMedia(r, !1);
                    })
                    .on("afterChange", function (i, a, o) {
                        t.trigger("refresh-zoom");
                        var n = e(a.$slides.get(o));
                        if ("local" === n.data("media-host")) {
                            var s = n[0].querySelector(".js-video");
                            s &&
                                ((s.style.width = "calc(100% - 1px)"),
                                setTimeout(() => {
                                    s.style.width = "100%";
                                }));
                        }
                    });
            (this.Image = function (i) {
                (this.destroy = function () {
                    t.trigger("zoom.destroy");
                }),
                    (this.pause = function () {
                        t.trigger("zoom.destroy");
                    }),
                    t.closest(".quickbuy-form").length && e.colorbox.resize();
            }),
                (this.Video = function (e) {
                    var t,
                        i = e[0],
                        a = i.querySelector(".product-media__poster"),
                        n = i.querySelector("template");
                    if (n) {
                        var s = i.querySelector(".product-media--frame-inner");
                        theme.browser.isSafari() && "local" === i.dataset.mediaHost && n.content.querySelector(".js-video").setAttribute("autoplay", "autoplay"),
                            s.appendChild(n.content),
                            n.remove(),
                            (s.style.paddingBottom = 100 / i.querySelector("video, iframe").getAttribute("aspect-ratio") + "%"),
                            e.closest(".slick-slider").slick("refresh"),
                            (t = i.querySelector(".js-video")),
                            theme.viewport.isSm() && a.classList.add("product-media__poster--hide");
                    }
                    (this.play = function () {
                        if (t)
                            switch (i.dataset.mediaHost) {
                                case "youtube":
                                    t.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                                    break;
                                case "vimeo":
                                    t.contentWindow.postMessage('{"method":"play"}', "*");
                                    break;
                                case "local":
                                    t.play();
                            }
                        a.classList.add("product-media__poster--hide");
                    }),
                        (this.pause = function () {
                            if (t)
                                switch (i.dataset.mediaHost) {
                                    case "youtube":
                                        t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                                        break;
                                    case "vimeo":
                                        t.contentWindow.postMessage('{"method":"pause"}', "*");
                                        break;
                                    case "local":
                                        t.pause();
                                }
                        }),
                        (this.destroy = function () {}),
                        a.addEventListener("click", this.play, { once: !0 }),
                        (o[e.data("media-id")] = this);
                }),
                (this.Model = function (i) {
                    var a = { play: function e() {}, pause: function e() {}, destroy: function e() {} },
                        s = i.find("model-viewer")[0];
                    (this.init = function () {
                        window.ShopifyXR && n.length && (n.attr("data-shopify-model3d-id", i.data("media-id")), window.ShopifyXR.setupXRElements());
                    }),
                        (this.play = function () {
                            a.play();
                        }),
                        (this.pause = function () {
                            window.ShopifyXR && n.length && (n.attr("data-shopify-model3d-id", n.data("shopify-model3d-first-id")), n.attr("data-shopify-title", n.data("shopify-first-title")), window.ShopifyXR.setupXRElements());
                        }),
                        (this.destroy = function () {}),
                        (this.initAugmentedReality = function () {
                            if (e(".model-json", t).length) {
                                var i = function i() {
                                    if (!window.ShopifyXR) {
                                        document.addEventListener("shopify_xr_initialized", function e(t) {
                                            i(), t.target.removeEventListener(t.type, e);
                                        });
                                        return;
                                    }
                                    window.ShopifyXR.addModels(JSON.parse(e(".model-json", t).html())), window.ShopifyXR.setupXRElements();
                                };
                                window.Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: i }]);
                            }
                        }),
                        theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
                        window.Shopify.loadFeatures([
                            {
                                name: "model-viewer-ui",
                                version: "1.0",
                                onLoad: function () {
                                    a = new Shopify.ModelViewerUI(s);
                                }.bind(this),
                            },
                        ]),
                        i.find("model-viewer").on("shopify_model_viewer_ui_toggle_play", function () {
                            i.addClass("product-media-model--playing"), u.slick("slickSetOption", "swipe", !1), u.slick("slickSetOption", "accessibility", !1);
                        }),
                        i.find("model-viewer").on("shopify_model_viewer_ui_toggle_pause", function () {
                            i.removeClass("product-media-model--playing"), u.slick("slickSetOption", "swipe", !0), u.slick("slickSetOption", "accessibility", !0);
                        }),
                        (o[i.data("media-id")] = this),
                        window.ShopifyXR || this.initAugmentedReality();
                }),
                (this.pauseAllMedia = function () {
                    for (var e in o) o.hasOwnProperty(e) && o[e].pause();
                }),
                (this.setCurrentMedia = function (t, n, s) {
                    var r = !(arguments.length > 3) || void 0 === arguments[3] || arguments[3];
                    if (t.length) {
                        n && ((c = !s), u.slick("slickGoTo", t.data("slick-index"), l), (l = !1)), this.pauseAllMedia();
                        var d = function i(a) {
                            var n;
                            return "function" == typeof (n = o.hasOwnProperty(t.data("media-id")) ? o[t.data("media-id")] : new a(t)).init ? n.init() : e(window).width() >= 768 && "function" == typeof n.play && r && n.play(), n;
                        };
                        "image" === t.data("media-type") ? (i = d(a.Image)) : "video" === t.data("media-type") ? (i = d(a.Video)) : "model" === t.data("media-type") ? (i = d(a.Model)) : console.warn("CC: Media is unknown", t);
                    }
                }),
                (this.destroy = function () {
                    for (var i in o) o.hasOwnProperty(i) && o[i].destroy();
                    e(".main a.main-img-link--lightbox", t).off("click"),
                        e(".thumbnails .thumbnail", t).off("click"),
                        e(".thumbnails", t).slick("unslick").off("init reInit setPosition"),
                        e(".product-slideshow", t).slick("unslick"),
                        t.off("variantImageSelected");
                }),
                setTimeout(() => {
                    t.find(".product-media").each(function (t) {
                        a.setCurrentMedia(e(this), !1, !1, !1);
                    });
                }, 1e3),
                ((0 === t.find(".product-media--image").length && 1 === t.find(".product-gallery--hover-veil").length) || (t.data("enable-zoom") && theme.device.isTouch())) && t.find(".product-gallery--hover-veil").remove(),
                t.on("click", ".main a.main-img-link--lightbox", function () {
                    return (
                        e(window).height() >= 580 &&
                            e(window).width() >= 768 &&
                            (1 == t.find("img:not(.zoomImg)").length
                                ? e.colorbox({ href: e(this).attr("href"), minWidth: "200", maxWidth: "96%", maxHeight: "96%" })
                                : (e("#gallery-cont").remove(),
                                  e('<div id="gallery-cont"/>')
                                      .append(t.find(".thumbnails a[data-media-type='image']").clone().attr({ rel: "gallery", title: "" }))
                                      .hide()
                                      .appendTo("body")
                                      .children()
                                      .colorbox({ className: "product-gallery--popup", minWidth: "200", maxWidth: "96%", maxHeight: "96%", next: theme.icons.right, previous: theme.icons.left, close: theme.icons.close })
                                      .filter('[href="' + e(this).attr("href") + '"]')
                                      .first()
                                      .click())),
                        !1
                    );
                }),
                t.on("click", ".thumbnails .thumbnail", function (i) {
                    i.preventDefault();
                    var o = t.find('.product-media[data-media-id="'.concat(e(this).data("media-id"), '"]'));
                    a.setCurrentMedia(o, !0, !1);
                }),
                t.on("variantImageSelected", function (e, i) {
                    var o = t.find('.product-media[data-media-id="'.concat(i.featured_media.id, '"]'));
                    a.setCurrentMedia(o, !0, !0);
                }),
                t.on("initzoom", function () {
                    if (s) {
                        var i;
                        function a() {
                            var e = t.find(".main .product-media.slick-active .main-img-link");
                            if (e.length && e.attr("href") !== i) {
                                t.removeClass("gallery-loaded");
                                var a = new Image();
                                (a.onload = () => {
                                    setTimeout(() => {
                                        t.addClass("gallery-loaded");
                                    }, 0);
                                }),
                                    (a.src = e.attr("href")),
                                    (i = e.attr("href")),
                                    e.trigger("zoom.destroy").removeClass("zoom-enabled"),
                                    theme.viewport.isSm() && t.width() < t.data("full-image-width") && !e.hasClass("zoom-enabled") && e.zoom({ url: e.attr("href") }).addClass("zoom-enabled");
                            }
                        }
                        a(), e(window).on("debouncedresize", a), t.on("refresh-zoom", a);
                    }
                }),
                t.trigger("initzoom");
        }),
        (theme.initProductForm = function (t) {
            var i = theme.OptionManager.getProductData(t),
                a = t.find(".qty-adjuster");
            theme.OptionManager.initProductOptions(e('[name="id"]', t));
            var o = "," + t.find(".option-selectors").data("box-options") + ",";
            if (
                e(".selector-wrapper:not(.has-clickyboxes) select", t)
                    .filter(function () {
                        return o.indexOf("," + e(this).closest(".selector-wrapper").find("label").html() + ",") >= 0;
                    })
                    .clickyBoxes()
                    .parent()
                    .addClass("has-clickyboxes").length > 0
            )
                for (var n = 0; n < i.options.length; n++) {
                    for (var s = {}, r = 0; r < i.variants.length; r++) {
                        var c = i.variants[r];
                        void 0 === s[c.options[n]] && (s[c.options[n]] = !1), c.available && (s[c.options[n]] = !0);
                    }
                    for (var l in s)
                        s[l] ||
                            e(".selector-wrapper:eq(" + n + ") .clickyboxes li a", t)
                                .filter(function () {
                                    return e(this).attr("data-value") == l;
                                })
                                .addClass("unavailable");
                }
            function d() {
                var i,
                    o = t.find('select[name="id"]').val(),
                    n = JSON.parse(e("#LimitedCartJson").html()),
                    s = !1;
                if (
                    (n &&
                        n.items &&
                        o &&
                        (s = n.items.some((e) => {
                            if (e.id == o) return (i = e), !0;
                        })),
                    a.attr("data-line-item-id", o),
                    s)
                ) {
                    var r = t.find(".product-add");
                    r.removeClass("product-add--adding"),
                        r.attr("data-btn-type", "in-cart"),
                        r.find(".button-text").text(theme.strings.removeFromCart),
                        theme.loadInPlaceQuantityAdjustment(t.parent(), n),
                        theme.applyAjaxToProductForm(t.parent()),
                        t.find(".qty-adjuster__value").val(i.quantity),
                        theme.updateAdjusterButtonsDisabledState(a, !1, !0);
                } else t.removeClass("product-form--added"), theme.updateAdjusterButtonsDisabledState(a, !0), t.find(".qty-adjuster--loading").removeClass("qty-adjuster--loading");
            }
            t.find('select:not([name="id"])').selectReplace().closest(".selector-wrapper").addClass("has-pretty-select"),
                t.closest(".quickbuy-form").length &&
                    t.find('[name="id"]').on("change", function () {
                        setTimeout(function () {
                            e.colorbox.resize();
                        }, 10);
                    });
            var u = t.hasClass("product-form--not-quickbuy");
            u &&
                (d(),
                e(window).on("cc-cart-updated", () => {
                    e('[name="id"]', t).trigger("change");
                })),
                e(window).on("cc-variant-updated.ajax-buttons".concat(i.id), (e, o) => {
                    if (o.product.id === i.id) {
                        o.variant.available && u ? d() : theme.updateAdjusterButtonsDisabledState(a, !0);
                        var n = t.find(".variant-swatch-value");
                        n.length && n.html(": ".concat(n.closest(".selector-wrapper").find(".active").html()));
                    }
                });
        }),
        (theme.unloadProductForm = function (t) {
            theme.OptionManager.unloadProductOptions(e('[name="id"]', t)),
                t.find('[name="id"]').off("change"),
                t.find(".clickybox-replaced").clickyBoxes("destroy"),
                e("select.replaced", t).selectReplace("destroy"),
                t.find(".qty-adjuster").off("click");
            var i = theme.OptionManager.getProductData(t);
            i && e(window).off("cc-variant-updated.ajax-buttons".concat(i.id));
        }),
        (theme.applyAjaxToProductForm = function (t) {
            var i = theme.routes.cart_add_url + ".js";
            theme.routes.cart_url,
                t.filter('[data-ajax-add-to-cart="true"]').on("submit", function (t) {
                    t.preventDefault();
                    var a = e(this),
                        o = 1,
                        n = a.find(".qty-adjuster__value");
                    n.length && (o = n.val()),
                        a
                            .find(":submit")
                            .attr("disabled", "disabled")
                            .each(function () {
                                e(this).addClass("product-add--adding");
                            });
                    var s = a.find(":submit");
                    theme.cartLoadingStarted();
                    var r = a.serialize();
                    -1 === r.indexOf("quantity=") && (r += "&quantity=".concat(o)),
                        e
                            .post(
                                i,
                                r,
                                function (t) {
                                    theme.utils.cookie.create("theme_added_to_cart", "justnow", 1),
                                        dispatchCustomEvent(CustomEvents.cartItemAdded, { product: t }),
                                        s
                                            .each(function () {
                                                var t = e(this);
                                                setTimeout(() => {
                                                    t.addClass("product-add--added").removeAttr("disabled"),
                                                        setTimeout(() => {
                                                            t.removeClass("product-add--added").removeClass("product-add--adding");
                                                        }, 2e3);
                                                }, 500);
                                            })
                                            .first(),
                                        theme.updateCartSummaries(a.data("open-cart-drawer") || (theme.settings.openCartDrawerOnMob && 1100 > e(window).outerWidth()), !0, !a.hasClass("product-form--not-quickbuy"));
                                },
                                "json"
                            )
                            .fail(function (t) {
                                var i = a
                                    .find(":submit")
                                    .removeAttr("disabled")
                                    .each(function () {
                                        var t = e(this);
                                        t[t.is("button") ? "html" : "val"](t.data("previous-value"));
                                    })
                                    .first();
                                if (void 0 !== t && void 0 !== t.status) {
                                    var o = e.parseJSON(t.responseText);
                                    theme.showQuickPopup(o.description, n && n.length ? n : i);
                                } else a.attr("ajax-add-to-cart", "false").submit();
                                s.each(function () {
                                    e(this).removeClass("product-add--adding");
                                });
                            })
                            .always(function () {
                                theme.cartLoadingFinished();
                            });
                });
        }),
        (theme.removeAjaxFromProductForm = function (e) {
            e.off("submit");
        }),
        (theme.updateAdjusterButtonsDisabledState = function (e, t, i) {
            var a = e.find(".qty-adjuster__value"),
                o = e.attr("data-limit");
            o && (o = parseInt(o)), t && a.val("1");
            var n = parseInt(a.val());
            e.closest(".variant-status--unavailable").length
                ? e.find(".qty-adjuster__up,.qty-adjuster__down").attr("disabled", "disabled")
                : (n === o ? e.find(".qty-adjuster__up").attr("disabled", "disabled") : e.find(".qty-adjuster__up").removeAttr("disabled"),
                  n > 1 ? e.find(".qty-adjuster__down").removeAttr("disabled") : i ? e.find(".qty-adjuster__down").removeAttr("disabled") : e.find(".qty-adjuster__down").attr("disabled", "disabled")),
                a.removeAttr("disabled");
        }),
        (theme.disableInPlaceQuantityAdjustment = function (e) {
            e.addClass("qty-adjuster--loading");
        }),
        (theme.enableInPlaceQuantityAdjustment = function (e) {
            e.removeClass("qty-adjuster--loading");
        }),
        (theme.loadInPlaceQuantityAdjustment = function (t, i) {
            if (e(".qty-adjuster:first", t).length && theme.settings.cartType.includes("drawer")) {
                function a(i) {
                    e(".product-form--mini", t).addClass("product-form--temp-could-remove");
                    for (var a = 0; a < i.items.length; a++) {
                        var o = i.items[a],
                            n = null,
                            s = e('.product-form--mini[data-product-id="' + o.product_id + '"]', t);
                        if (s) {
                            var r = s.find(".product-add");
                            r.length && r.css("height", r.outerHeight() + "px"),
                                s.addClass("product-form--added").removeClass("product-form--temp-could-remove"),
                                (n = s.parent().find(".qty-adjuster")),
                                s.hasClass("product-form--not-quickbuy") || n.attr("data-line-item-id", o.id);
                        }
                        n || (n = e('.qty-adjuster[data-line-item-id="' + o.id + '"]', t)),
                            n &&
                                (n.removeClass("qty-adjuster--loading"),
                                s.hasClass("product-form--not-quickbuy") || n.find(".qty-adjuster__value").val(o.quantity),
                                n.find(".qty-adjuster__value").removeAttr("disabled"),
                                theme.updateAdjusterButtonsDisabledState(n, !1, !0));
                    }
                    e(".product-form--temp-could-remove", t).removeClass("product-form--added product-form--temp-could-remove");
                }
                i ? a(i) : e.getJSON(theme.routes.cart_url + ".js", a);
            }
        }),
        (theme.unloadInPlaceQuantityAdjustment = function (e) {}),
        (theme.cartUpdatingRemoveTimeout = -1),
        (theme.cartLoadingStarted = function () {
            e("body").addClass("updating-cart");
        }),
        (theme.cartLoadingFinished = function () {
            clearTimeout(theme.cartUpdatingRemoveTimeout),
                setTimeout(function () {
                    e("body").removeClass("updating-cart");
                }, 500);
        }),
        (theme.updateCartSummaries = function (t, i, a) {
            theme.cartLoadingStarted();
            var o = e(".cart-summary__item-list:first").scrollTop(),
                n = e(".cart-summary__inner:first").scrollTop();
            e.get(theme.routes.search_url, function (s) {
                for (
                    var r,
                        c = [".toolbar-cart .current-cart", ".cart-summary"],
                        l = e(e.parseHTML("<div>" + s + "</div>"))
                            .wrap("<div>")
                            .parent(),
                        d = 0;
                    d < c.length;
                    d++
                ) {
                    var u = c[d],
                        h = l.find(u).clone();
                    h.find(".fade-in").removeClass("fade-in");
                    var p = e(u),
                        f = h.find(".cart-summary__buttons");
                    f.length && f.css("height", p.find(".cart-summary__buttons").outerHeight() + "px");
                    var m = h.find(".cart-summary-item-container").eq(0);
                    p.find('.cart-summary-item-container[data-product-id="'.concat(m.data("product-id"), '"]')).length && (i = !1), i && m.length && m.addClass("cart-summary-item-container--out-left").hide();
                    var v = e(".cart-form--checkout", p),
                        g = e(".cart-form--non-stick", p);
                    v.hasClass("cart-form--checkout--sticky-true") && g.length && h.find(".cart-form--checkout").css("top", -Math.abs(parseInt(g.outerHeight() + 1)) + "px"),
                        p.replaceWith(h),
                        i && m.length && (m.slideDown(300), m.removeClass("cart-summary-item-container--out-left")),
                        f.length &&
                            setTimeout(function () {
                                e(u).find(".cart-summary__buttons").css("height", "auto");
                            }, 1e3);
                }
                e("#LimitedCartJson").length &&
                    ((r = JSON.parse(e("#LimitedCartJson").html())),
                    a
                        ? setTimeout(() => {
                              theme.loadInPlaceQuantityAdjustment(e("body"), r);
                          }, 800)
                        : theme.loadInPlaceQuantityAdjustment(e("body"), r),
                    theme.applyAjaxToProductForm(e(".cart-summary form.product-form"))),
                    theme.loadCartNoteMonitor(e(".cart-summary")),
                    e(".cart-summary__item-list:first").scrollTop(o),
                    e(".cart-summary__inner:first").scrollTop(n),
                    "page" != theme.settings.cartType &&
                        (t &&
                            setTimeout(function () {
                                e("body").addClass("show-cart-summary product-added-to-cart"),
                                    setTimeout(function () {
                                        e(".cart-summary__close").focus();
                                    }, 200);
                            }, 20),
                        e(".cart-summary.updating, .cart-summary .updating").removeClass("updating"),
                        r && e(window).trigger("cc-cart-updated", { cartItemData: r }));
            }).always(function () {
                theme.cartLoadingFinished();
            });
        }),
        (theme.carousels = {
            init: () => {
                var t = this;
                (t.updateArrows = (t) => {
                    var i = e(t).closest(".section")[0];
                    t.scrollLeft < 15 ? i.classList.add("cc-start") : i.classList.remove("cc-start"),
                        t.scrollLeft + t.clientWidth > t.scrollWidth - 15 ? i.classList.add("cc-end") : (i.classList.remove("cc-end"), i.classList.add("cc-carousel-scrolling"));
                }),
                    (t.initArrows = () => {
                        document.querySelectorAll(".cc-carousel").forEach((i) => {
                            var a = e(i).closest(".section"),
                                o = a.find(".cc-carousel--next"),
                                n = a.find(".cc-carousel--previous");
                            o.addClass("cc-initialized"),
                                n.addClass("cc-initialized"),
                                o.length &&
                                    n.length &&
                                    (o.on("click.cc-carousel", function () {
                                        var a = -1,
                                            o = e(this).closest(".section").find(".cc-carousel").offset().left;
                                        e(i)
                                            .find(".column")
                                            .each(function () {
                                                var t = parseInt(e(this).offset().left - o);
                                                t > i.scrollLeft + i.clientWidth - 20 && -1 === a && (a = t);
                                            }),
                                            -1 === a && (a = i.scrollLeft + i.clientWidth),
                                            t.scrollLeft(i, a);
                                    }),
                                    n.on("click.cc-carousel", function () {
                                        var a = -1;
                                        if (theme.viewport.isXs()) {
                                            var o = e(this).closest(".section").find(".cc-carousel").offset().left,
                                                n = {};
                                            e(i)
                                                .find(".column")
                                                .each(function (t) {
                                                    var s = parseInt(e(this).offset().left - o);
                                                    s >= 0 && -1 === a && (a = e(this).hasClass("min-cols-2") && n[t - 2] ? i.scrollLeft + n[t - 2] : i.scrollLeft + n[t - 1]), (n[t] = s);
                                                });
                                        }
                                        -1 === a && (a = i.scrollLeft - i.clientWidth), t.scrollLeft(i, a);
                                    })),
                                t.updateArrows(i);
                        });
                    }),
                    (t.scrollLeft = (e, i) => {
                        e.classList.add("cc-carousel--smooth-scroll"),
                            (e.scrollLeft = i),
                            setTimeout(() => {
                                t.updateArrows(e), e.classList.remove("cc-carousel--smooth-scroll");
                            }, scrollSpeed);
                    }),
                    (t.initMobileCarousels = () => {
                        theme.viewport.isXs()
                            ? document.querySelectorAll(".cc-carousel-mobile:not(.cc-carousel)").forEach((t) => {
                                  t.classList.add("cc-carousel");
                                  var i = e(t).closest(".section");
                                  i.find(".cc-carousel--next").addClass("cc-initialized"), i.find(".cc-carousel--previous").addClass("cc-initialized"), i.addClass("cc-is-carousel");
                              })
                            : document.querySelectorAll(".cc-carousel-mobile.cc-carousel").forEach((t) => {
                                  t.classList.remove("cc-carousel");
                                  var i = e(t).closest(".section");
                                  i.find(".cc-carousel--next").removeClass("cc-initialized"), i.find(".cc-carousel--previous").removeClass("cc-initialized"), i.removeClass("cc-is-carousel");
                              });
                    }),
                    (t.initCarousels = () => {
                        var e = document.querySelectorAll(".cc-carousel");
                        e.length &&
                            (theme.viewport.isSm() && !theme.browser.isSafari()
                                ? e.forEach((e) => {
                                      var i,
                                          a,
                                          o = !1;
                                      e.classList.contains("cc-initialized") ||
                                          (e.classList.add("cc-initialized"),
                                          e.addEventListener("mousedown", (t) => {
                                              (o = !0), (i = t.pageX - e.offsetLeft), (a = e.scrollLeft);
                                          }),
                                          e.addEventListener("mouseleave", () => {
                                              o = !1;
                                          }),
                                          e.addEventListener("mouseup", () => {
                                              (o = !1), t.updateArrows(e);
                                          }),
                                          e.addEventListener("mousemove", (n) => {
                                              if (o) {
                                                  n.preventDefault();
                                                  var s = n.pageX - e.offsetLeft - i;
                                                  (e.scrollLeft = a - s), t.updateArrows(e);
                                              }
                                          }));
                                  })
                                : e.forEach((e) => {
                                      var i;
                                      e.addEventListener("touchend", () => {
                                          t.updateArrows(e);
                                      }),
                                          e.addEventListener(
                                              "scroll",
                                              () => {
                                                  clearTimeout(i),
                                                      (i = setTimeout(() => {
                                                          t.updateArrows(e);
                                                      }, 300));
                                              },
                                              { passive: !0 }
                                          );
                                  }),
                            t.initArrows());
                    }),
                    document.querySelectorAll(".cc-carousel-mobile").length && (e(window).off("debouncedresizewidth.cc-carousel").on("debouncedresizewidth.cc-carousel", t.initMobileCarousels), t.initMobileCarousels()),
                    t.initCarousels();
            },
            destroy() {
                var t = document.querySelector(".cc-carousel");
                t &&
                    t.length &&
                    t.forEach((t) => {
                        t.removeEventListener("mousedown").removeEventListener("mouseleave").removeEventListener("mouseup").removeEventListener("mousemove").classList.remove("cc-initialized");
                        var i = e(t).closest(".section");
                        i.find(".cc-carousel--previous").removeClass("cc-initialized"), i.find(".cc-carousel--next").removeClass("cc-initialized");
                    }),
                    e(window).off(".cc-carousel");
            },
        }),
        e(function (e) {
            var t = null;
            e(document).on("click", ".quick-buy", function (a) {
                if (t) return !1;
                var o,
                    n = e(this),
                    s = e('.quickbuy-placeholder-template[data-product-id="' + n.data("product-id") + '"]:first').html(),
                    r = e('<div class="quickbuy-container">' + s + "</div>"),
                    c = null,
                    l = null,
                    d = e(this).closest(".product-block"),
                    u = d.parent().children(".product-block".concat("hover" === theme.settings.quickBuyType ? ":not('.page-block'):not(.product-block--flex-spacer)" : ".product-block--with-quickbuy"));
                if (
                    d.length &&
                    (u.each(function (t) {
                        e(this).attr("id") === d.attr("id") && (o = t);
                    }),
                    null != o)
                ) {
                    o > 0 && (c = u.eq(o - 1).attr("id"));
                    var h = u.eq(o + 1);
                    h && (l = h.attr("id"));
                }
                return (
                    e.colorbox({
                        closeButton: !1,
                        preloading: !1,
                        open: !0,
                        speed: 200,
                        html: [
                            '<div class="action-icons">',
                            null != c ? '<a href="#" class="prev-item action-icon" data-idx="' + c + '" aria-label="' + theme.strings.previous + '">' + theme.icons.left + "</span></a>" : "",
                            null != l ? '<a href="#" class="next-item action-icon" data-idx="' + l + '" aria-label="' + theme.strings.next + '">' + theme.icons.right + "</a>" : "",
                            '<a href="#" class="close-box action-icon" aria-label="',
                            theme.strings.close,
                            '">' + theme.icons.close + "</a>",
                            "</div>",
                            r.wrap("<div>").parent().html(),
                        ].join(""),
                        onComplete: function e() {
                            i(n.attr("href"));
                        },
                        onCleanup: function t() {
                            theme.activeQuickBuyMediaGallery && theme.activeQuickBuyMediaGallery.destroy(), theme.unloadProductForm(e(".quickbuy-container .product-form"));
                        },
                    }),
                    a.stopImmediatePropagation(),
                    !1
                );
            });
            var i = function i(a) {
                (t = e.get(a, function (i) {
                    var o = e("<div>").append(e(i).find('.section-product-template [data-section-type="product-template"]').clone());
                    o.find("[data-cc-animate]").removeAttr("data-cc-animate"),
                        o.find(".product-collection-links").remove(),
                        o.find(".store-availability-container-outer").remove(),
                        o.find(".social-links").remove(),
                        o.find("[data-enable-history-state]").attr("data-enable-history-state", "false"),
                        o.find(".theme-product-reviews-full").remove(),
                        o.find(".product-mob-collection-links").remove(),
                        o.find('[data-show-in-quickbuy="false"]').remove(),
                        o.find(".product-description-below").remove(),
                        o.find(".product-section.border-bottom").removeClass("border-bottom"),
                        o.find(".product-container").addClass("product-container--quickbuy"),
                        o
                            .find(".product-details")
                            .append('<div class="more-link-row"><a class="more-link" href="'.concat(a, '">').concat(theme.strings.fullDetails, '<span class="more-link-icon">' + theme.icons.arrowRight + "</span></a></div>"));
                    var n = e('<div class="quickbuy-form quickbuy-form--overlay">' + o.html() + "</div>"),
                        s = e(".quickbuy-container");
                    s.html(n), e("body").removeClass("product-added-to-cart");
                    var r = s.find(".product-container .product-gallery");
                    1 === r.length && (theme.activeQuickBuyMediaGallery = new theme.ProductMediaGallery(r)),
                        theme.initProductForm(s.find(".product-form")),
                        e(".quickbuy-form").imagesLoaded(function () {
                            setTimeout(e.colorbox.resize, 10);
                        }),
                        n.hide().fadeIn(300, function () {
                            e(".quickbuy-form.placeholder").remove(), n.removeClass("quickbuy-form--overlay"), e.colorbox.resize();
                        }),
                        Shopify.PaymentButton &&
                            (e(document).on("shopify:payment_button:loaded.themeQuickBuy", function () {
                                e(document).off("shopify:payment_button:loaded.themeQuickBuy"), e.colorbox.resize();
                            }),
                            Shopify.PaymentButton.init()),
                        theme.initAnimateOnScroll(),
                        e(document).trigger("cc:component:load", ["accordion", e(".quickbuy-container")[0]]),
                        (t = null);
                })),
                    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            };
        });
    class C {
        constructor(e) {
            if (!e) {
                console.warn("No container provided to StickyScrollDirection component");
                return;
            }
            (this.container = e), (this.currentTop = 0), (this.scrollY = window.scrollY), this.updateDefaultTop(), theme.viewport.isSm() && this.bindEvents();
        }
        bindEvents() {
            (this.scrollListener = this.handleScroll.bind(this)),
                (this.updateTopListener = theme.debounce(this.updateDefaultTop.bind(this))),
                window.addEventListener("scroll", this.scrollListener),
                window.addEventListener("cc-header-updated", this.updateTopListener),
                window.addEventListener("resize", this.updateTopListener);
        }
        updateDefaultTop() {
            var t = e(".product-list-toolbar");
            t ? (this.defaultTop = t.outerHeight() + 20) : (this.defaultTop = 0);
        }
        handleScroll() {
            var e = this.container.getBoundingClientRect().top + window.scrollY - this.container.offsetTop + this.defaultTop,
                t = this.container.clientHeight - window.innerHeight;
            window.scrollY < this.scrollY ? (this.currentTop -= window.scrollY - this.scrollY) : (this.currentTop += this.scrollY - window.scrollY),
                (this.currentTop = Math.min(Math.max(this.currentTop, -t), e, this.defaultTop)),
                (this.scrollY = window.scrollY),
                (this.container.style.top = this.currentTop + "px");
        }
        destroy() {
            window.removeEventListener("scroll", this.scrollListener), window.removeEventListener("cc-header-updated", this.updateTopListener), window.removeEventListener("resize", this.updateTopListener);
        }
    }
    new (class e extends h {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "sticky-scroll-direction",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e, ":not(.cc-initialized)");
            super(e, t);
        }
        init(e) {
            super.init(e), this.registerInstance(e, new C(e));
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e);
        }
    })(),
        (theme.FooterSection = new (function () {
            (this.onSectionLoad = function (t) {
                e(".disclosure", t).each(function () {
                    e(this).data("disclosure", new theme.Disclosure(e(this)));
                });
            }),
                (this.onSectionUnload = function (t) {
                    e(".disclosure", t).each(function () {
                        e(this).data("disclosure").unload();
                    });
                });
        })()),
        (theme.CartDrawerSection = new (function () {
            (this.onSectionLoad = function (t) {
                theme.applyAjaxToProductForm(e("form.product-form", t)), theme.loadCartNoteMonitor(t);
                var i = e("body"),
                    a = e(window);
                function o() {
                    0 === a.scrollTop() ? i.addClass("scrolled-top") : i.removeClass("scrolled-top");
                }
                function n() {
                    var i = e(".cart-form--checkout", t),
                        a = e(".cart-form--non-stick", t);
                    i.hasClass("cart-form--checkout--sticky-true") && a.length && i.css("top", -Math.abs(parseInt(a.outerHeight() + 1)) + "px");
                }
                o(),
                    theme.viewport.isSm() && e(window).on("throttled-scroll.cartDrawer", o),
                    e(t).on("click", ".btn--empty-cart", function () {
                        return (
                            confirm(theme.strings.confirmEmptyCart) &&
                                (e(t)
                                    .find(".cart-summary-item-container")
                                    .each(function (t) {
                                        setTimeout(() => {
                                            e(this).addClass("cart-summary-item-container--out");
                                        }, 50 * t);
                                    }),
                                e.post(theme.routes.cart_clear_url, function () {
                                    theme.updateCartSummaries(!1, !1);
                                })),
                            !1
                        );
                    }),
                    e(t).on("click", ".cart-accordion-btn", function (t) {
                        t.preventDefault(), t.stopImmediatePropagation();
                        var i = e(this).parent().next().toggleClass("hidden").hasClass("hidden");
                        e(this).toggleClass("cart-accordion-btn--collapsed", i), i || e(this).closest(".cart-summary").find(".cart-accordion-btn:not(.cart-accordion-btn--collapsed)").not(this).click();
                    }),
                    e(t).on("click", ".cart-accordion-btn-container", function (t) {
                        t.preventDefault(), e(this).find(".cart-accordion-btn").click();
                    }),
                    n(),
                    e(window).on("debouncedresize.cartDrawer cc-cart-updated", n);
            }),
                (this.onSectionUnload = function (t) {
                    theme.removeAjaxFromProductForm(e("form.product-form", t)), theme.unloadCartNoteMonitor(t), e(window).off(".cartDrawer");
                }),
                (this.onSectionSelect = function (t) {
                    e("body").hasClass("show-cart-summary") || e(".toggle-cart-summary:first").click();
                }),
                (this.onSectionDeselect = function (t) {
                    e("body").hasClass("show-cart-summary") && e(".toggle-cart-summary:first").click();
                });
        })()),
        (theme.SlideshowSection = new (function () {
            (this.onSectionLoad = function (t) {
                theme.initContentSlider(t), e(t).find(".image-overlay--mobile-stack").length > 0 ? e(t).parent().addClass("slideshow-section--mobile-stack") : e(t).parent().addClass("slideshow-section--no-mobile-stack");
            }),
                (this.onSectionUnload = function (t) {
                    e(".slick-slider", t).slick("unslick").off("init"), e(window).off(".slideshowSection");
                }),
                (this.onBlockSelect = function (t) {
                    e(t).closest(".slick-slider").slick("slickGoTo", e(t).data("slick-index")).slick("slickPause");
                }),
                (this.onBlockDeselect = function (t) {
                    e(t).closest(".slick-slider").slick("slickPlay");
                });
        })()),
        (theme.ProductTemplateSection = new (function () {
            var t = [];
            (this.onSectionLoad = function (i) {
                e("[data-store-availability-container]", i).length && (this.storeAvailability = new theme.StoreAvailability(e("[data-store-availability-container]", i)[0])),
                    e(".product-gallery", i).each(function () {
                        t.push(new theme.ProductMediaGallery(e(this)));
                    }),
                    e(".product-form:not(.product-form--placeholder)", i).length && theme.initProductForm(e(".product-form", i)),
                    e(".cc-rating-container", i).length &&
                        (e("#shopify-product-reviews").length
                            ? e(i).on("click", ".cc-rating-container", function () {
                                  return theme.viewport.scrollTo(e("#shopify-product-reviews"), -1, 500, 100, 1 === e('.header-container[data-is-sticky="true"]').length), !1;
                              })
                            : e(".cc-rating-container", i).css("cursor", "default")),
                    e(i).on("click", ".size-chart-link", function () {
                        e.colorbox({ inline: !0, href: "#size-chart-content > .size-chart" });
                    }),
                    e(window).trigger("normheights");
            }),
                (this.onSectionUnload = function (i) {
                    if ((e(i).off("click"), e(".product-gallery .thumbnails", i).slick("unslick"), t.length)) for (var a = 0; a < t.length; a++) t[a].destroy();
                    theme.unloadProductForm(e(".product-form", i)), this.storeAvailability && this.storeAvailability.onSectionUnload(), e(".product-slideshow", i).slick("unslick").off("init");
                });
        })()),
        (theme.FilterManager = new (function () {
            (this.onSectionLoad = function (t) {
                (this.namespace = theme.namespaceFromSection(t)),
                    (this.$container = e(t)),
                    (this.$productFilter = e(".cc-product-filter", this.$container)),
                    (this.filters_closed_cookie_name = "theme_filters_closed"),
                    this.$container.data("ajax-filtering")
                        ? (this.$container.on("click" + this.namespace, ".pagination a,.active-filter-controls a", this.functions.ajaxLoadLink.bind(this)),
                          this.$container.on("change" + this.namespace + " submit" + this.namespace, "[data-filter-form]", theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)),
                          this.registerEventListener(window, "popstate", this.functions.ajaxPopState.bind(this)))
                        : this.$container.on("change" + this.namespace, "[data-filter-form]", this.functions.submitForm),
                    this.$container.on("click" + this.namespace, ".cc-toolbar-filter-toggle", this.functions.toggleFilter.bind(this)),
                    this.$container.on("click" + this.namespace, ".cc-product-filter__mob-veil, .cc-product-filter__close", this.functions.handleMobileVeilTap.bind(this)),
                    this.$container.on("submit" + this.namespace, "#search-page-form", this.functions.updateSearchQuery.bind(this)),
                    theme.viewport.isSm() &&
                        theme.utils.cookie.exists(this.filters_closed_cookie_name) &&
                        "true" == theme.utils.cookie.read(this.filters_closed_cookie_name) &&
                        e(t).addClass("cc-filters-closed").addClass("cc-filters-closed-no-trans"),
                    e("select:not([name=id])", t).selectReplace(),
                    this.$container.data("use-infinite-scroll") ? (theme.loadProductGrid(this.$container), this.functions.initInfiniteScroll()) : theme.loadProductGrid(t);
            }),
                (this.functions = {
                    initInfiniteScroll: function t() {
                        e(".product-list.use-infinite-scroll", this.$container).each(function () {
                            var t = e(this);
                            theme.loadScriptOnce(theme.scripts.jqueryInfiniteScroll, function () {
                                t.infinitescroll(
                                    {
                                        navSelector: ".pagination",
                                        nextSelector: ".pagination .next",
                                        itemSelector: ".product-list .product-block",
                                        loading: { msgText: theme.strings.infiniteScrollCollectionLoading, finishedMsg: theme.strings.infiniteScrollCollectionFinishedMsg },
                                        pathParse: function e(t, i) {
                                            return t.match(/^(.*page=)[0-9]*(&.*)?$/).splice(1);
                                        },
                                    },
                                    function (e) {
                                        t.find("#infscr-loading").remove(), t.find(".product-block:not(.product-block--flex-spacer):last").prevAll(".product-block--flex-spacer").remove(), theme.loadProductGrid(this.$container);
                                    }
                                );
                            });
                        });
                    },
                    updateSearchQuery: function t(i) {
                        var a = this.$container.find("[data-filter-form]:first");
                        a.length &&
                            ((i.preventDefault(), a.find('[name="q"]').val(e(i.currentTarget).find('[name="q"]').val()), this.$container.data("ajax-filtering"))
                                ? this.functions.ajaxLoadForm.bind(this)({ type: null, currentTarget: a[0] })
                                : a.submit());
                    },
                    submitForm: function e(t) {
                        t.currentTarget.submit();
                    },
                    handleMobileVeilTap: function e() {
                        this.$container.toggleClass("cc-filters-mob-open");
                    },
                    toggleFilter: function e() {
                        return (
                            this.$container.removeClass("cc-filters-closed-no-trans"),
                            theme.viewport.isXs()
                                ? this.$container.toggleClass("cc-filters-mob-open")
                                : this.$container.hasClass("cc-filters-closed")
                                ? (theme.utils.cookie.create(this.filters_closed_cookie_name, "false", 365), this.$container.removeClass("cc-filters-closed"))
                                : (theme.utils.cookie.create(this.filters_closed_cookie_name, "true", 365), this.$container.addClass("cc-filters-closed")),
                            !1
                        );
                    },
                    ajaxLoadLink: function t(i) {
                        i.preventDefault(), this.functions.ajaxLoadUrl.call(this, e(i.currentTarget).attr("href"));
                    },
                    ajaxLoadForm: function e(t) {
                        "submit" === t.type && t.preventDefault();
                        var i = [];
                        this.$container[0].querySelectorAll("[data-filter-form] input, [data-filter-form] select").forEach((e) => {
                            (("checkbox" !== e.type && "radio" !== e.type) || e.checked) &&
                                "" !== e.value &&
                                ("" === e.value && e.dataset.currentValue ? i.push([e.name, encodeURIComponent(e.dataset.currentValue)]) : i.push([e.name, encodeURIComponent(e.value)]));
                        }),
                            this.$container[0].querySelectorAll("[data-filter-form] [data-current-value]").forEach((e) => {
                                e.setAttribute("value", e.dataset.currentValue);
                            });
                        var a = new FormData(t.currentTarget),
                            o = new URLSearchParams(a).toString();
                        this.functions.ajaxLoadUrl.call(this, "?" + o);
                    },
                    ajaxPopState: function e(t) {
                        this.functions.ajaxLoadUrl.call(this, document.location.href);
                    },
                    initFilterResults: function t() {
                        this.$container.data("use-infinite-scroll") && this.functions.initInfiniteScroll(), theme.loadProductGrid(this.$container), theme.initAnimateOnScroll();
                        var i = this.$container.closest("[data-components]");
                        i.length &&
                            i
                                .data("components")
                                .split(",")
                                .forEach(
                                    function (t) {
                                        e(document).trigger("cc:component:load", [t, i[0]]);
                                    }.bind(this)
                                );
                    },
                    refreshSelects: function t() {
                        e("select:not(.original-selector)", this.$container).selectReplace().closest(".selector-wrapper").addClass("has-pretty-select");
                    },
                    ajaxLoadUrl: function t(i) {
                        var a = this,
                            o = i;
                        "/" === o.slice(0, 1) && (o = window.location.protocol + "//" + window.location.host + o);
                        var n = "[data-ajax-container]",
                            s = this.$container.find(".product-list-toolbar"),
                            r = this.$container.find(n);
                        r.addClass("cc-product-filter-container--loading"),
                            this.currentAjaxLoadUrlFetch && this.currentAjaxLoadUrlFetch.abort(),
                            (this.currentAjaxLoadUrlFetch = e.get(
                                i,
                                function (t) {
                                    this.currentAjaxLoadUrlFetch = null;
                                    var i = e(e.parseHTML(t)).filter("title").text().trim();
                                    if (
                                        ((document.title = i),
                                        window.history.pushState({ path: o }, i, o),
                                        document.activeElement && (this.activeElementId = document.activeElement.id),
                                        e("<div>".concat(t, "</div>"))
                                            .find(n)
                                            .each(function (t) {
                                                var i = e(this);
                                                e(r[t])
                                                    .find(".cc-accordion-item")
                                                    .each(function () {
                                                        var t = e(this).closest(".cc-accordion").index();
                                                        e(this).hasClass("is-open")
                                                            ? i
                                                                  .find(".cc-accordion:nth-child(".concat(t + 1, ") .cc-accordion-item"))
                                                                  .addClass("is-open")
                                                                  .attr("open", "")
                                                            : i
                                                                  .find(".cc-accordion:nth-child(".concat(t + 1, ") .cc-accordion-item"))
                                                                  .removeClass("is-open")
                                                                  .removeAttr("open");
                                                    }),
                                                    e(".cc-product-filter", a.$container).length && e(".cc-product-filter", a.$container).hasClass("-in") && i.find(".cc-product-filter").addClass("-in"),
                                                    e(r[t]).html(i.html());
                                            }),
                                        s && (0 === e("<div>".concat(t, "</div>")).find(".product-list-toolbar").length ? s.hide() : s.show()),
                                        a.functions.refreshSelects(),
                                        this.functions.initFilterResults.call(this),
                                        r.removeClass("cc-product-filter-container--loading"),
                                        this.activeElementId)
                                    ) {
                                        var c = document.getElementById(this.activeElementId);
                                        c && c.focus();
                                    }
                                    var l = e("[data-ajax-scroll-to]:first", this.$container);
                                    if (e(window).scrollTop() - 200 > l.offset().top) {
                                        if (this.$container.data("is-sticky")) var d = theme.viewport.isSm() ? 25 : 0;
                                        else var d = e('.header-container[data-is-sticky="true"]').outerHeight();
                                        theme.viewport.scrollTo(l, -1, 1e3, d);
                                    }
                                }.bind(this)
                            ));
                    },
                }),
                (this.onSectionUnload = function (t) {
                    e("select.replaced", t).selectReplace("destroy"), theme.unloadProductGrid(t);
                });
        })()),
        (theme.CollectionListingSection = new (function () {
            (this.onSectionLoad = function (t) {
                e(window).trigger("normheights"), theme.loadProductGrid(t);
            }),
                (this.onSectionUnload = function (e) {
                    theme.unloadProductGrid(e);
                });
        })()),
        (theme.FeaturedCollectionSection = new (function () {
            (this.onSectionLoad = function (e) {
                theme.loadProductGrid(e);
            }),
                (this.onSectionUnload = function (e) {
                    theme.unloadProductGrid(e);
                });
        })()),
        (theme.FeaturedCollectionsSection = new (function () {
            this.onSectionLoad = function (t) {
                e(window).trigger("normheights");
            };
        })()),
        (theme.GallerySection = new (function () {
            (this.onSectionLoad = function (t) {
                var i = e(".gallery--mobile-carousel", t);
                if (i.length) {
                    var a = function t() {
                        var a = i.hasClass("slick-slider"),
                            o = theme.viewport.isXs();
                        if ((o || e(".lazyload--manual", i).removeClass("lazyload--manual").addClass("lazyload"), a && !o)) {
                            i.slick("unslick").off("init"), i.find("a, .gallery__item").removeAttr("tabindex").removeAttr("role");
                            var n = i.data("grid"),
                                s = null;
                            i.find(".gallery__item").each(function (t) {
                                t % n == 0 && (s = e('<div class="gallery__row">').appendTo(i)), e(this).appendTo(s);
                            });
                        } else
                            !a &&
                                o &&
                                (i.find(".gallery__item").appendTo(i),
                                i.find(".gallery__row").remove(),
                                i
                                    .on("init", function () {
                                        e(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
                                    })
                                    .slick({ autoplay: !1, fade: !1, infinite: !1, useTransform: !0, arrows: !1, dots: !0 }));
                    };
                    a(), e(window).on("debouncedresize.themeSection" + t.id, a);
                }
            }),
                (this.onSectionUnload = function (t) {
                    e(window).off(".themeSection" + t.id),
                        e(".slick-slider", t).each(function () {
                            e(this).slick("unslick").off("init");
                        });
                }),
                (this.onBlockSelect = function (t) {
                    e(t)
                        .closest(".slick-slider")
                        .each(function () {
                            e(this).slick("slickGoTo", e(this).data("slick-index")).slick("slickPause");
                        });
                }),
                (this.onBlockDeselect = function (t) {
                    e(t)
                        .closest(".slick-slider")
                        .each(function () {
                            e(this).slick("slickPlay");
                        });
                });
        })()),
        (theme.HeaderSection = new (function () {
            (this.onSectionLoad = function (t) {
                e("body").append(e("#mobile-navigation-template", t).html());
                var i = e("#localization_form_header");
                if (i.length) {
                    var a = e("#localization--mobile-menu"),
                        o = e(".localization--header"),
                        n = function e() {
                            theme.viewport.isXs() ? i.appendTo(a) : 0 === o.find("#localization_form_header").length && (i.appendTo(o), o.removeAttr("style"));
                        };
                    if ((n(), window.matchMedia)) {
                        var s = window.matchMedia("(min-width: 768px)");
                        s.addEventListener &&
                            s.addEventListener("change", (e) => {
                                e.matches, n();
                            });
                    }
                }
                function r() {
                    e(this).attr("aria-expanded", !e(this).siblings().is(":visible")),
                        e(this).parent().toggleClass("sub-nav-item--expanded", !e(this).siblings().is(":visible")),
                        e(this).parent().parent().toggleClass("is-expanded", !e(this).siblings().is(":visible")),
                        e(this).siblings().slideToggle(250);
                }
                if ((e("#mobile-nav .sub-nav a, #mobile-nav .sub-nav button").attr("tabindex", "-1"), e(".main-nav", t).length)) {
                    e(".main-nav .sub-nav-item.has-dropdown > a", t).on("keypress", function (t) {
                        32 === t.keyCode &&
                            (e(".sub-nav-item.has-dropdown > a").attr("aria-expanded", "false"),
                            e(".sub-nav-item.has-dropdown > a").parent().parent().removeClass("is-expanded"),
                            e(".sub-nav-item.has-dropdown > a").parent().removeClass("sub-nav-item--expanded"),
                            e(".sub-nav-item.has-dropdown > a").siblings().css("display", "none"),
                            r.call(this)),
                            t.preventDefault();
                    }),
                        e(".main-nav", t)
                            .on("click", ".sub-nav-item.has-dropdown > a", function () {
                                return (
                                    e(".sub-nav-item.has-dropdown > a").attr("aria-expanded", "false"),
                                    e(".sub-nav-item.has-dropdown > a").parent().parent().removeClass("is-expanded"),
                                    e(".sub-nav-item.has-dropdown > a").parent().removeClass("sub-nav-item--expanded"),
                                    e(".sub-nav-item.has-dropdown > a").siblings().css("display", "none"),
                                    r.call(this),
                                    !1
                                );
                            })
                            .filter("[data-col-limit]")
                            .each(function () {
                                var t = e(this).data("col-limit");
                                t > 0 &&
                                    e(".nav-item.dropdown.drop-norm > .sub-nav", this).each(function () {
                                        for (var i = e(this).find(".sub-nav-list:not(.sub-nav-image) > .sub-nav-item"), a = Math.ceil(i.length / t), o = 1; o < a; o++)
                                            e('<ul class="sub-nav-list"/>')
                                                .append(i.slice(t * o))
                                                .insertAfter(e(this).find(".sub-nav-list:not(.sub-nav-image):last"));
                                    });
                            });
                    var c,
                        l = e(),
                        d = -1;
                    e(t),
                        e(".main-nav", t).on("mouseenter mouseleave", ".nav-item.dropdown", function (t) {
                            var i = e(t.currentTarget);
                            if ("mouseenter" == t.type) {
                                clearTimeout(d), clearTimeout(i.data("navCloseTimeoutId"));
                                var a = i.siblings(".open");
                                a.not(l).removeClass("open"), (l = i);
                                var o = setTimeout(
                                    function () {
                                        i.addClass("open").siblings(".open").removeClass("open");
                                        var t = i.filter(".drop-norm").children(".sub-nav");
                                        if (t.length) {
                                            var a = "",
                                                o = e("#page-wrap").width() - 30;
                                            if (i.closest(".align-center").length) {
                                                var n,
                                                    s = i.offset().left + i.outerWidth() / 2 - t.outerWidth() / 2 - 30;
                                                if (s < 0) a = "translateX(calc(50% + " + Math.round(Math.abs(s)) + "px))";
                                                else {
                                                    var r = i.offset().left + i.outerWidth() / 2 + t.outerWidth() / 2,
                                                        c = r - o;
                                                    c > 0 && (a = "translateX(calc(50% - " + Math.round(c) + "px))");
                                                }
                                            } else {
                                                var r = i.offset().left + t.outerWidth(),
                                                    c = r - o;
                                                c > 0 && (a = "translateX(-" + Math.round(c) + "px)");
                                            }
                                            t.css("transform", a);
                                        }
                                    },
                                    0 == a.length ? 0 : 250
                                );
                                (d = o), i.data("navOpenTimeoutId", o);
                            } else
                                clearTimeout(i.data("navOpenTimeoutId")),
                                    i.data(
                                        "navCloseTimeoutId",
                                        setTimeout(function () {
                                            i.removeClass("open").children(".sub-nav").css("transform", "");
                                        }, 250)
                                    );
                            i.children("[aria-expanded]").attr("aria-expanded", "mouseenter" == t.type);
                        }),
                        e(".main-nav", t).on("touchstart touchend click", ".nav-item.dropdown > .nav-item-link", function (t) {
                            if ("touchstart" == t.type) e(this).data("touchstartedAt", t.timeStamp);
                            else if ("touchend" == t.type) {
                                if (t.timeStamp - e(this).data("touchstartedAt") < 1e3)
                                    return (
                                        e(this).data("touchOpenTriggeredAt", t.timeStamp),
                                        e(this).parent().hasClass("open") ? e(this).parent().trigger("mouseleave") : (e(".nav-item.open").trigger("mouseleave"), e(this).parent().trigger("mouseenter")),
                                        !1
                                    );
                            } else if ("click" == t.type && e(this).data("touchOpenTriggeredAt") && t.timeStamp - e(this).data("touchOpenTriggeredAt") < 1e3) return !1;
                        }),
                        e(".main-nav", t).on("keydown", ".nav-item.dropdown > .nav-item-link", function (t) {
                            if (32 == t.which) {
                                var i = e(t.target).parent();
                                return i.trigger(i.hasClass("open") ? "mouseleave" : "mouseenter"), !1;
                            }
                        });
                    var u = e("#logo-spacer", t),
                        h = e(".logo-item", t);
                    function p() {
                        e(window).width() !== c &&
                            (setTimeout(function () {
                                var t = e(".main-nav").width() + e(".main-nav").offset().left;
                                e(".main-nav .nav-item.drop-norm .sub-nav")
                                    .css("transform", "")
                                    .each(function () {
                                        e(this).css({ visibility: "hidden", zIndex: -1 }).css({ display: "block" });
                                        var i = t - (e(this).offset().left + e(this).outerWidth()),
                                            a = e(this).offset().left;
                                        i < 0 ? e(this).css("transform", "translate(" + Math.ceil(i - 1) + "px)") : a < 0 && e(this).css("transform", "translate(" + Math.ceil(-a) + "px)"),
                                            e(this).css({ visibility: "", zIndex: "", display: "" });
                                    });
                            }, 50),
                            (c = e(window).width()));
                    }
                    e(window)
                        .on("debouncedresize.headerSection doNavResizeEvents.headerSection", function e() {
                            u.length && h.length && u.css("width", h.outerWidth());
                        })
                        .trigger("doNavResizeEvents"),
                        e(window).on("debouncedresize.headerSection ensuredropdownposition.headerSection", p).trigger("ensuredropdownposition"),
                        e(function () {
                            p();
                        });
                }
                e("select:not([name=id])", t).selectReplace(),
                    e(".disclosure", t)
                        .add("#mobile-nav .disclosure")
                        .each(function () {
                            e(this).data("disclosure", new theme.Disclosure(e(this)));
                        });
                var f = e('.main-search[data-live-search="true"]', t),
                    m = f.find("form"),
                    v = f.find(".main_search__popup"),
                    g = f.find(".main-search__results"),
                    y = v.find(".main-search__footer-buttons"),
                    b = v.find(".all-results-container");
                if (f.length) {
                    var $ = e(".main-search__input", t),
                        k = theme.utils.getUrlParameter("filter.p.product_type");
                    if (k && k.length > 0) {
                        var w = e(".main-search__product-types", t);
                        w && w.val(k).trigger("change");
                    }
                    var C = new (function () {
                            return {
                                popup: {
                                    show: function e() {
                                        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                                            i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                                            a = !(arguments.length > 2) || void 0 === arguments[2] || arguments[2];
                                        (g.html().length > 0 || !0 === t || !0 === i || $.val().length >= 3) && ((0 === g.html().length || !0 === i) && !0 === a && j.call($), f.addClass("main-search--show-popup")),
                                            v.attr("aria-expanded", !0);
                                    },
                                    hide() {
                                        f.removeClass("main-search--show-popup"), v.attr("aria-expanded", !1);
                                    },
                                },
                                hiddenSearch: {
                                    hide() {
                                        var t = f.closest(".hidden-search-container");
                                        t.length > 0 && (t.removeClass("hidden-search-container--open"), e("body").removeClass("hidden-search-container--open"));
                                    },
                                },
                            };
                        })(),
                        T = -1,
                        S = null,
                        x = f.data("live-search-price"),
                        _ = f.data("live-search-vendor"),
                        L = f.data("live-search-meta"),
                        E = f.data("show-sold-out-label"),
                        A = f.data("show-sale-label"),
                        M = null;
                    function j() {
                        var t = e(this).closest(".main-search"),
                            i = t.find(".main-search__results"),
                            a = t.find(".main-search__product-types:visible"),
                            o = e(this).val(),
                            n = a.length > 0 ? a.val() : "";
                        if (o.length > 2 && (o != $.data("oldval") || 0 === a.length || n != $.data("oldtype"))) {
                            $.data("oldval", o), $.data("oldtype", n), null != S && S.abort(), clearTimeout(T);
                            var s = e(this).closest("form").eq(0),
                                r = s.attr("action") + (s.attr("action").indexOf("?") > -1 ? "&" : "?") + s.serialize();
                            t.removeClass("main-search--has-results main-search--results-on-multiple-lines main-search--no-results").addClass("main-search--loading"),
                                v.css("height", v.outerHeight() + "px"),
                                C.popup.show(!0, !1, !1),
                                b.empty(),
                                y.hide(),
                                0 === e(".main-search__results-spinner").length && i.html('<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>'),
                                (T = setTimeout(function () {
                                    var a, c;
                                    theme.Shopify.features.predictiveSearch
                                        ? ((a = theme.routes.search_url + "/suggest.json"),
                                          (c = {
                                              q: "".concat(n.length > 0 ? "product_type:" + n + "+*" : "", " ").concat(o),
                                              resources: {
                                                  type: s.find('input[name="type"]').val(),
                                                  limit: 8,
                                                  options: { unavailable_products: "last", fields: L ? "title,product_type,variants.title,vendor,tag,variants.sku" : "title,product_type,variants.title,vendor" },
                                              },
                                          }))
                                        : ((a = r + "&view=json"), (c = null)),
                                        (S = e.ajax({
                                            url: a,
                                            data: c,
                                            dataType: "json",
                                            success: function a(o) {
                                                (S = null), t.removeClass("main-search--has-results main-search--results-on-multiple-lines main-search--no-results"), i.empty();
                                                var n = e('<div class="main-search__results__products collection-listing"><div class="product-list product-list--per-row-4 product-list--image-shape-natural"></div></div>'),
                                                    s = e('<div class="main-search__results__pages">');
                                                if (o.resources.results.products)
                                                    for (var c = 0; c < o.resources.results.products.length; c++) {
                                                        var l = o.resources.results.products[c],
                                                            d = e(
                                                                '<div class="main-search-result"><div class="block-inner"><div class="block-inner-inner"><div class="image-cont"><a class="product-link"><div class="image-label-wrap"><div class="primary-image"></div></div></a></div><div class="product-info"><div class="inner"><div class="innerer"><a class="product-link"><div class="product-block__title"></div></a></div></div></div></div></div></div>'
                                                            );
                                                        if ((d.find(".product-link").attr("href", l.url), l.featured_image && l.featured_image.url)) {
                                                            var u = e('<div class="rimage-outer-wrapper"><div class="rimage-wrapper lazyload--placeholder"><img loading="lazy" class="rimage__image"/></div></div>').appendTo(
                                                                d.find(".primary-image")
                                                            );
                                                            u.find(".rimage-wrapper").css("padding-top", (1 / Math.max(l.featured_image.aspect_ratio, 0.6)) * 100 + "%"),
                                                                u.find(".rimage__image").attr("data-lazy-src", theme.Shopify.formatImage(l.featured_image.url, "{width}x"));
                                                        }
                                                        var h = d.find(".product-info .product-link");
                                                        if ((h.find(".product-block__title").html(l.title), _ && e('<div class="vendor">').html(l.vendor).prependTo(h), x)) {
                                                            var p = e('<div class="product-price">').appendTo(h);
                                                            l.price_max != l.price_min && (e('<span class="product-price__from">').html(theme.strings.products_listing_from).appendTo(p), p.append(" ")),
                                                                parseFloat(l.compare_at_price_min) > parseFloat(l.price_min)
                                                                    ? (e('<span class="product-price__amount product-price__amount--on-sale theme-money reduced-price">').html(theme.formatMoney(l.price_min)).appendTo(p),
                                                                      p.append(" "),
                                                                      e('<span class="product-price__compare theme-money struck-out-price">').html(theme.formatMoney(l.compare_at_price_min)).appendTo(p))
                                                                    : e('<span class="product-price__amount theme-money">').html(theme.formatMoney(l.price_min)).appendTo(p);
                                                        }
                                                        E && !l.available
                                                            ? e('<span class="product-label product-label--soldout"><span>'.concat(theme.strings.products_labels_sold_out, "</span></span>")).appendTo(d.find(".product-info"))
                                                            : A &&
                                                              parseFloat(l.compare_at_price_min) > parseFloat(l.price_min) &&
                                                              e('<span class="product-label product-label--sale"><span>'.concat(theme.strings.products_labels_sale, "</span></span>")).appendTo(d.find(".product-info")),
                                                            n.children().append(d);
                                                    }
                                                if (o.resources.results.pages)
                                                    for (var c = 0; c < o.resources.results.pages.length; c++) {
                                                        var l = o.resources.results.pages[c],
                                                            d = e('<a class="main-search-result main-search-result--page">').attr("href", l.url);
                                                        e('<div class="main-search-result__text">').html(l.title).appendTo(d), s.append(d);
                                                    }
                                                if (o.resources.results.articles)
                                                    for (var c = 0; c < o.resources.results.articles.length; c++) {
                                                        var l = o.resources.results.articles[c],
                                                            d = e('<a class="main-search-result main-search-result--article">').attr("href", l.url);
                                                        e('<div class="main-search-result__text">').html(l.title).appendTo(d), s.append(d);
                                                    }
                                                v.css("height", "auto"), t.removeClass("main-search--loading");
                                                var f = n.find(".main-search-result:first").length > 0,
                                                    m = s.find(".main-search-result:first").length > 0;
                                                f || m
                                                    ? (t.addClass("main-search--has-results"),
                                                      t.toggleClass("main-search--results-on-multiple-lines", n.find(".product-block").length > 4),
                                                      f && i.append(n),
                                                      m && (e('<h6 class="main-search-result__heading">').html(theme.strings.general_quick_search_pages).prependTo(s), i.append(s)),
                                                      e('<a class="main-search__results-all-link btn">')
                                                          .attr("href", r)
                                                          .html(theme.strings.layout_live_search_see_all + theme.icons.chevronRight)
                                                          .appendTo(b),
                                                      y.css("display", "flex"))
                                                    : (t.addClass("main-search--no-results"), e('<div class="main-search__empty-message">').html(theme.strings.general_quick_search_no_results).appendTo(i));
                                            },
                                            error: function e(t) {},
                                        }));
                                }, 500));
                        } else
                            e(this).val().length <= 2 &&
                                ($.data("oldval", o),
                                $.data("oldtype", n),
                                null != S && S.abort(),
                                clearTimeout(T),
                                C.popup.hide(),
                                setTimeout(() => {
                                    v.css("height", "auto"), t.removeClass("main-search--has-results main-search--results-on-multiple-lines main-search--loading"), i.empty(), b.empty(), y.hide();
                                }, 50));
                    }
                    e(t).on("keyup.headerSection change.headerSection", ".main-search__input:visible", function () {
                        e(this).closest(".hidden-search-container--mob-only").length ? theme.viewport.isXs() && j.call(this) : M !== e(this).val() && (j.call(this), (M = e(this).val()));
                    }),
                        e(t).on("click.headerSection", ".main-search__input", C.popup.show),
                        e(t).on("focus.headerSection", ".main-search__input", function () {
                            C.popup.show(), e(this).select();
                        }),
                        e(t).on("change.headerSection", ".main-search__product-types", function () {
                            $.val().length >= 3 && C.popup.show(!0, !0);
                        }),
                        e(t).on("click.headerSection", ".main-search__results-close-link", function () {
                            return C.popup.hide(), C.hiddenSearch.hide(), !1;
                        });
                    var D = e(".hidden-search-container", t),
                        P = e(".hidden-search-container .main-search", t);
                    if (D.length) {
                        var q = e("#toolbar", t).closest(".container");
                        function V() {
                            theme.viewport.isXs() && e(".hidden-search-container .main-search", t).length > 0
                                ? q.append(P.addClass("main-search--revealable"))
                                : theme.viewport.isSm() && 0 === e(".hidden-search-container .main-search", t).length && D.append(P.removeClass("main-search--revealable").css("display", ""));
                        }
                        e(t).on("click.headerSection", "[data-show-search-form]", function () {
                            return (
                                D.find(".main-search").length
                                    ? (D.addClass("hidden-search-container--open"),
                                      e("body").addClass("hidden-search-container--open"),
                                      setTimeout(() => {
                                          D.find(".main-search__input").focus();
                                      }, 100))
                                    : theme.browser.isSafari()
                                    ? (q.find(".main-search").toggleClass("-in").show(), q.find(".main-search__input").focus())
                                    : q
                                          .find(".main-search")
                                          .slideToggle(200, function () {
                                              setTimeout(() => {
                                                  q.find(".main-search__input").focus();
                                              }, 100);
                                          })
                                          .toggleClass("-in"),
                                !1
                            );
                        }),
                            e(window).on("debouncedresize.headerSection", V),
                            V();
                    }
                    e(t).on("keyup.headerSection", (e) => {
                        27 === e.which && (C.popup.hide(), C.hiddenSearch.hide());
                    }),
                        e("body").on("click.headerSection", (e) => {
                            0 === m.has(e.target).length && (C.popup.hide(), C.hiddenSearch.hide());
                        });
                }
                var z = [];
                e(document)
                    .on("click", "#mobile-nav .open-sub-nav", function () {
                        var t = e("#mobile-nav .inner:not(.hide), #mobile-nav .sub-nav.show:not(.hide)").addClass("hide");
                        return (
                            t.find("a, button").attr("tabindex", "-1"),
                            z.push(t),
                            e('#mobile-nav .sub-nav[data-is-subnav-for="' + e(this).data("sub-nav") + '"]')
                                .first()
                                .addClass("show")
                                .find("a, button")
                                .removeAttr("tabindex"),
                            e(this).attr("aria-expanded", !0),
                            !1
                        );
                    })
                    .on("click", "#mobile-nav .close-sub-nav", function () {
                        e(this).closest(".sub-nav").removeClass("show").find("a, button").attr("tabindex", "-1");
                        var t = z.pop().removeClass("hide");
                        return t.find("a, button").removeAttr("tabindex"), t.find('[aria-expanded="true"]').removeAttr("aria-expanded"), !1;
                    })
                    .on("click", '#mobile-nav a.nav-item-link[href="#"], #mobile-nav a.sub-nav-item-link[href="#"]', function () {
                        return e(this).closest("li").find("button").click(), !1;
                    });
            }),
                (this.onSectionUnload = function (t) {
                    e(".main-nav", t).off("click mouseenter mouseleave touchstart touchend keydown"),
                        e("#mobile-nav").remove(),
                        e(window).off(".headerSection"),
                        e(t).off(".headerSection"),
                        e(".disclosure", t)
                            .add("#mobile-nav .disclosure")
                            .each(function () {
                                e(this).data("disclosure").unload();
                            }),
                        e("select.replaced", t).selectReplace("destroy");
                });
        })()),
        (theme.AnnouncementBarSection = new (function () {
            (this.onSectionLoad = function (t) {
                e(".disclosure", t).each(function () {
                    e(this).data("disclosure", new theme.Disclosure(e(this)));
                });
                var i = e(".announcement-bar__spacer", t);
                if (i.length > 1) {
                    function a() {
                        var t = 0;
                        i.each(function () {
                            e(this).width() > t && (t = e(this).width());
                        }),
                            i.width(parseInt(t));
                    }
                    e(window).on("debouncedresize.announcementBarSection", a), a();
                }
            }),
                (this.onSectionUnload = function (t) {
                    e(".disclosure", t).each(function () {
                        e(this).data("disclosure").unload();
                    }),
                        e(window).off(".announcementBarSection");
                });
        })()),
        (theme.BlogTemplateSection = new (function () {
            (this.onSectionLoad = function (t) {
                if (
                    (e("select:not([name=id])", t).selectReplace(),
                    e(".use-masonry", t).each(function () {
                        var t = e(this);
                        (window.$ = window.jQuery = e),
                            theme.loadScriptOnce(theme.scripts.masonry, function () {
                                t.addClass("masonry").masonry({ itemSelector: ".article", visibleStyle: { opacity: 1, transform: "translate3d(0,0,0)" }, hiddenStyle: { opacity: 0, transform: "translate3d(0,20px,0)" } }),
                                    setTimeout(function () {
                                        e(function () {
                                            t.masonry();
                                        });
                                    }, 10);
                            });
                    }),
                    e(".articles.use-infinite-scroll", t).each(function () {
                        var t = e(this);
                        (window.$ = window.jQuery = e),
                            theme.loadScriptOnce(theme.scripts.jqueryInfiniteScroll, function () {
                                t.infinitescroll(
                                    {
                                        navSelector: ".pagination",
                                        nextSelector: ".pagination .next",
                                        itemSelector: ".articles .article",
                                        loading: { msgText: theme.strings.infiniteScrollBlogLoading, finishedMsg: theme.strings.infiniteScrollBlogFinishedMsg },
                                        pathParse: function e(t, i) {
                                            return t.match(/^(.*page=)[0-9]*(&.*)?$/).splice(1);
                                        },
                                    },
                                    function (i) {
                                        t.find("#infscr-loading").remove(),
                                            t.hasClass("masonry") &&
                                                e(i)
                                                    .hide()
                                                    .imagesLoaded(function () {
                                                        e(i).show(), t.masonry("appended", e(i), !0);
                                                    }),
                                            theme.initAnimateOnScroll();
                                    }
                                );
                            });
                    }),
                    e(".page-title.opposing-items .tags", t).length > 0)
                ) {
                    function i() {
                        var t = e(".page-title.opposing-items"),
                            i = t.children(".left"),
                            a = t.children(".tags");
                        t.toggleClass("collapse-tags", a.outerWidth(!0) > t.width() - i.outerWidth(!0)),
                            t.hasClass("collapse-tags") ? 0 == t.find(".more-link").length && a.before(['<a href="#" class="more-link">', theme.strings.blogsShowTags, "</a>"].join("")) : t.find(".more-link").remove();
                    }
                    e(window).on("debouncedresize.checktagswidth checktagswidth.checktagswidth", i).trigger("checktagswidth"),
                        e(function () {
                            i();
                        }),
                        e(document).on("click.checktagswidth", ".page-title.opposing-items.collapse-tags .more-link", function (t) {
                            t.preventDefault(), e(this).closest(".opposing-items").toggleClass("reveal-tags");
                        });
                }
            }),
                (this.onSectionUnload = function (t) {
                    e(window).off(".checktagswidth .blogTemplateMasonry"), e(document).off(".checktagswidth"), e("select.replaced", t).selectReplace("destroy");
                });
        })()),
        (theme.CartTemplateSection = new (function () {
            (this.onSectionLoad = function (t) {
                var i = this;
                (this.namespace = theme.namespaceFromSection(t)),
                    e("#shipping-calculator", t).length &&
                        theme.loadScriptOnce(
                            theme.scripts.underscore,
                            function () {
                                theme.loadScriptOnce(
                                    theme.scripts.shopifyCommon,
                                    function () {
                                        theme.loadScriptOnce(
                                            theme.scripts.jqueryCart,
                                            function () {
                                                Shopify.Cart.ShippingCalculator.show({
                                                    submitButton: theme.strings.shippingCalcSubmitButton,
                                                    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                                                    customerIsLoggedIn: theme.customerIsLoggedIn,
                                                    moneyFormat: theme.shippingCalcMoneyFormat,
                                                }),
                                                    e("select", this).selectReplace(),
                                                    setTimeout(
                                                        function () {
                                                            this.trigger("change");
                                                        }.bind(e("select", this)),
                                                        100
                                                    );
                                            }.bind(t)
                                        );
                                    },
                                    null,
                                    !0
                                );
                            },
                            null,
                            !0
                        ),
                    e(t).on("click".concat(this.namespace), ".qty-adjuster__remove", function () {
                        return !!confirm(theme.strings.cartConfirmRemove) && (!e(t).data("ajax-update") || (i.functions.updateCart.call(this, { line: e(this).data("line"), quantity: 0 }), !1));
                    }),
                    e(t).data("ajax-update") &&
                        (e(document).on("theme:cartchanged.cartTemplateSection", this.functions.refreshCartDependentContent.bind(this)),
                        e(t).on(
                            "change".concat(this.namespace, " changeFromButton").concat(this.namespace),
                            ".qty-adjuster__value",
                            function (t) {
                                var i,
                                    a = e(t.currentTarget);
                                !(this.replacingContent || (a.data("initial-value") && a.data("initial-value") === a.val())) &&
                                    0 !== a.val().length &&
                                    ((i = "changeFromButton" === t.type ? e(t.data).attr("id") : a.attr("id")),
                                    a.closest(".cart-item").addClass("cart-item-loading"),
                                    this.functions.updateCart.call(this, { line: a.data("line"), quantity: a.val() }, function () {
                                        e("#" + i).focus();
                                    }));
                            }.bind(this)
                        )),
                    theme.loadCartNoteMonitor(t);
            }),
                (this.functions = {
                    refreshCartDependentContent: function t() {
                        this.cartRefreshXhr && this.cartRefreshXhr.abort(),
                            (this.cartRefreshXhr = e.ajax({
                                type: "GET",
                                url: theme.routes.cart_url + "?view=ajax",
                                success: function (t) {
                                    var i = [".cart-items", ".cart-subtotal"],
                                        a = e("<div>" + t + "</div>");
                                    a.find("[data-cc-animate]").removeAttr("data-cc-animate");
                                    for (var o = 0; o < i.length; o++)
                                        a.find(i[o]).length
                                            ? ((this.replacingContent = !0), e('[data-section-type="cart-template"] ' + i[o]).html(a.find(i[o]).html()))
                                            : e('[data-section-type="cart-template"]').html(a.find('[data-section-type="cart-template"]').html()),
                                            (this.replacingContent = !1);
                                }.bind(this),
                                error: function t(i) {
                                    "abort" != i.statusText && (console.error("Error refreshing page", i), e("#cartform").submit());
                                },
                                complete: function () {
                                    this.cartRefreshXhr = null;
                                }.bind(this),
                            }));
                    },
                    updateCart: function t(i, a) {
                        this.cartXhr && this.cartXhr.abort(),
                            this.cartRefreshXhr && this.cartRefreshXhr.abort(),
                            (this.cartXhr = e.ajax({
                                type: "POST",
                                url: theme.routes.cart_change_url + ".js",
                                data: i,
                                dataType: "json",
                                success: function e() {
                                    document.documentElement.dispatchEvent(new CustomEvent("theme:cartchanged", { bubbles: !0, cancelable: !1 })), a && a();
                                },
                                error: function t(i) {
                                    "abort" != i.statusText && (console.error("Error updating cart", i), e("#cartform").submit());
                                },
                                complete: function () {
                                    this.cartXhr = null;
                                }.bind(this),
                            }));
                    },
                }),
                (this.onSectionUnload = function (t) {
                    e("#shipping-calculator #address_country", t).off("change"), e("#shipping-calculator .get-rates", t).off("click"), e("select.replaced", t).selectReplace("destroy"), theme.unloadCartNoteMonitor(t);
                });
        })()),
        (theme.ProductRecommendations = new (function () {
            this.onSectionLoad = function (e) {
                var t = e;
                if (null !== t) {
                    var i = new XMLHttpRequest();
                    i.open("GET", t.dataset.url, !0),
                        (i.onload = function () {
                            if (i.status >= 200 && i.status < 300) {
                                var e = document.createElement("div");
                                (e.innerHTML = i.response), (t.innerHTML = e.querySelector(".product-recommendations").innerHTML), theme.loadProductGrid(t), theme.carousels.init();
                            }
                        }),
                        i.send();
                }
            };
        })()),
        (theme.TestimonialsSection = new (function () {
            (this.onSectionLoad = function (e) {
                theme.initContentSlider(e);
            }),
                (this.onSectionUnload = function (t) {
                    e(".slick-slider", t).slick("unslick").off("init"), e(window).off(".testimonialsSection");
                }),
                (this.onBlockSelect = function (t) {
                    e(t).closest(".slick-slider").slick("slickGoTo", e(t).data("slick-index")).slick("slickPause");
                }),
                (this.onBlockDeselect = function (t) {
                    e(t).closest(".slick-slider").slick("slickPlay");
                });
        })()),
        e(function (e) {
            e(document).on("keyup.themeTabCheck", function (t) {
                9 === t.keyCode && (e("body").addClass("tab-used"), e(document).off("keyup.themeTabCheck"));
            }),
                e("select:not([name=id])")
                    .filter(function () {
                        e(this).closest(".product-form").length;
                    })
                    .selectReplace(),
                theme.uncontainImages(e("body")),
                e("a[rel=lightbox]").colorbox({ minWidth: "200", maxWidth: "96%", maxHeight: "96%" }),
                theme.carousels.init(),
                theme.assessFullWidthSections(),
                e(document).on("shopify:section:reorder", function (e) {
                    theme.assessFullWidthSections();
                }),
                e(document).on("shopify:section:load", function (t) {
                    theme.uncontainImages(t.target),
                        theme.assessFullWidthSections(),
                        theme.carousels.init(),
                        e(".section-background-video--inline", t.target).each(function () {
                            theme.VideoManager.onSectionLoad(e(this)[0]);
                        });
                }),
                e(document).on("shopify:section:unload", function (t) {
                    e(".section-background-video--inline", t.target).each(function () {
                        theme.VideoManager.onSectionUnload(e(this)[0]);
                    }),
                        theme.carousels.destroy();
                }),
                e(document).on("change", "select.redirect", function () {
                    window.location = e(this).val();
                }),
                e(document).on("click", ".sharing a", function (t) {
                    var i = e(this).parent();
                    if (i.hasClass("twitter")) {
                        t.preventDefault();
                        var a = e(this).attr("href"),
                            o = 575,
                            n = 450,
                            s = (e(window).width() - o) / 2,
                            r = (e(window).height() - n) / 2,
                            c = "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" + o + ",height=" + n + ",top=" + r + ",left=" + s;
                        window.open(a, "Twitter", c);
                    } else if (i.hasClass("facebook")) {
                        t.preventDefault();
                        var a = e(this).attr("href"),
                            o = 626,
                            n = 256,
                            s = (e(window).width() - o) / 2,
                            r = (e(window).height() - n) / 2,
                            c = "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" + o + ",height=" + n + ",top=" + r + ",left=" + s;
                        window.open(a, "Facebook", c);
                    } else if (i.hasClass("pinterest")) {
                        t.preventDefault();
                        var a = e(this).attr("href"),
                            o = 700,
                            n = 550,
                            s = (e(window).width() - o) / 2,
                            r = (e(window).height() - n) / 2,
                            c = "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" + o + ",height=" + n + ",top=" + r + ",left=" + s;
                        window.open(a, "Pinterest", c);
                    }
                }),
                e(document).on("click", "#page-overlay, .side-menu-header--close", function () {
                    return e("body").removeClass("show-cart-summary show-mobile-nav product-added-to-cart"), !1;
                }),
                e(document).on("click", ".toggle-mob-nav", function () {
                    return (
                        e(".cart-summary").removeClass("active"),
                        e("#mobile-nav").addClass("active"),
                        e("body").toggleClass("show-mobile-nav").hasClass("show-mobile-nav")
                            ? setTimeout(function () {
                                  e("#mobile-nav").attr("tabindex", "0").focus();
                              }, 500)
                            : setTimeout(function () {
                                  e("#mobile-nav").removeAttr("tabindex"), e("body a:first:visible").focus();
                              }, 500),
                        !1
                    );
                }),
                "off" != theme.useSideCartSummary &&
                    e(document).on("click", ".toggle-cart-summary", function () {
                        if (e(".cart-summary .toggle-cart-summary").is(":visible"))
                            return (
                                e("#mobile-nav").removeClass("active"),
                                e(".cart-summary").addClass("active"),
                                e("body").removeClass("product-added-to-cart"),
                                e("body").toggleClass("show-cart-summary").hasClass("show-cart-summary") &&
                                    setTimeout(function () {
                                        e(".cart-summary__close").focus();
                                    }, 200),
                                !1
                            );
                    }),
                e(document).on("keypress", ".qty-adjuster--ajax .qty-adjuster__value", function (t) {
                    return 13 === t.which ? (e(this).trigger("change"), !1) : (8 === t.which || 0 === t.which || (!(t.which < 48) && !(t.which > 57))) && void 0;
                }),
                e(document).on("click", ".qty-adjuster__down, .qty-adjuster__up", function (t) {
                    t.preventDefault();
                    var i = e(this).closest(".qty-adjuster"),
                        a = i.find(".qty-adjuster__value"),
                        o = parseInt(a.val()),
                        n = "/products/" + a.data("line-item-handle") + ".json",
                        s = parseInt(a.val()) + (e(this).hasClass("qty-adjuster__down") ? -1 : 1),
                        r = e(this).closest("[data-limit]").attr("data-limit");
                    o > s &&
                        (function (e) {
                            e.ajax({
                                url: n,
                                success: function (e) {
                                    datalayerRemoveItem(e.product);
                                },
                                error: function (e) {
                                    console.error(e.responseText);
                                },
                            });
                        })(jQuery),
                        o < s &&
                            (function (e) {
                                e.ajax({
                                    url: n,
                                    success: function (e) {
                                        datalayerAddToCart(e.product);
                                    },
                                    error: function (e) {
                                        console.error(e.responseText);
                                    },
                                });
                            })(jQuery),
                        r && (r = parseInt(r)),
                        r && s > r ? (theme.showQuickPopup(theme.strings.maximumQuantity.replace("[quantity]", r), a), a.val(r).trigger("change")) : a.val(s).trigger("change"),
                        theme.updateAdjusterButtonsDisabledState(i, !1);
                }),
                e(document).on("click", ".qty-adjuster--ajax .qty-adjuster__remove", function (t) {
                    t.preventDefault(), e(this).closest(".qty-adjuster").find(".qty-adjuster__value").val(0).trigger("change"), getRemovedItem();
                    var i = e(this).closest(".cart-summary-item-container");
                    i.addClass("cart-summary-item-container--out"), i.slideUp(300);
                }),
                e(document).on("click", '.btn[data-btn-type="in-cart"]', function (t) {
                    t.preventDefault();
                    var i = e(this).closest("form");
                    i
                        .find(":submit")
                        .attr("disabled", "disabled")
                        .each(function () {
                            e(this).addClass("product-add--adding");
                        }),
                        e('.cart-form .cart-summary-item-container[data-product-id="'.concat(i.find('select[name="id"]').val(), '"] .qty-adjuster__remove')).trigger("click");
                });
            var t = theme.debounce(function () {
                var t = e(this).closest(".qty-adjuster").attr("data-line-item-id"),
                    i = e('.qty-adjuster[data-line-item-id="'.concat(t, '"]'));
                theme.disableInPlaceQuantityAdjustment(i), theme.cartLoadingStarted();
                var a = e('.product-form--not-quickbuy .qty-adjuster[data-line-item-id="'.concat(t, '"]')).closest("form");
                a.length &&
                    a
                        .find(":submit")
                        .attr("disabled", "disabled")
                        .each(function () {
                            e(this).addClass("product-add--adding");
                        }),
                    e
                        .post(
                            theme.routes.cart_url + "/change.js",
                            { quantity: e(this).val(), id: t },
                            function (e) {
                                theme.updateCartSummaries(!1);
                            },
                            "json"
                        )
                        .fail(function () {
                            theme.enableInPlaceQuantityAdjustment(i);
                        })
                        .always(function () {
                            0 == i.find(".qty-adjuster__value").val() && theme.enableInPlaceQuantityAdjustment(i), theme.cartLoadingFinished();
                        });
            });
            function i() {
                e("[data-normheights]").each(function () {
                    var t = e(this).find(e(this).data("normheights")),
                        i = e(this).data("normheights-inner"),
                        a = 0,
                        o = 0,
                        n = [];
                    t.each(function (t) {
                        var s = e(this).find(i),
                            r = e(this).position().top;
                        0 == t ? (o = r) : r != o && (e(n).css("min-height", a), (r = e(this).position().top), (n.length = 0), (a = 0)), (o = r), n.push(this);
                        var c = s.height();
                        c > a && (a = c);
                    }),
                        e(n).css("min-height", a);
                }),
                    e(".product-grid").each(function () {
                        var t = e(this).find(".product-block .product-block__weight"),
                            i = 0;
                        t.each(function () {
                            i += e(this).text().replace("&nbsp;", "").trim().length;
                        }),
                            0 === i && t.remove();
                    }),
                    e(".product-grid.one-row").each(function () {
                        var t = 0,
                            i = e(this).find(".product-block:not(.product-block--flex-spacer)");
                        e(this).css("position", "relative"),
                            i.find(".product-block:not(.product-block--flex-spacer)").each(function (i) {
                                if (0 != e(this).position().top) return !1;
                                var a = e(this).outerHeight(!0);
                                a > t && (t = a);
                            }),
                            e(this).css("height", t),
                            i.removeClass("hidden").each(function (t) {
                                e(this).position().top > 0 && e(this).addClass("hidden");
                            }),
                            e(this).css({ height: "", position: "" });
                    });
            }
            function a() {
                e("#page-wrap-inner").css("min-height", e(window).height());
            }
            e(document).on("change", ".qty-adjuster--ajax .qty-adjuster__value", function (i) {
                var a = e(this).closest("form");
                a.hasClass("product-form--not-quickbuy") ? a.hasClass("product-form--added") && t.call(this) : t.call(this);
            }),
                e(document).on("click", 'a[href^="#"]:not([href="#"]):not(.skip-link):not(.ignore-scroll)', function (t) {
                    var i = e(e(this).attr("href")).first();
                    1 == i.length && (e("html:not(:animated),body:not(:animated)").animate({ scrollTop: i.offset().top }, 500), t.preventDefault());
                }),
                theme.utils.cookie.exists("theme_added_to_cart") && "justnow" == theme.utils.cookie.read("theme_added_to_cart") && (theme.utils.cookie.erase("theme_added_to_cart"), theme.updateCartSummaries(!1)),
                e(window).on("debouncedresize normheights", i).trigger("normheights"),
                e(function () {
                    i();
                }),
                e(document)
                    .on("click", "#colorbox .close-box", function () {
                        return e.colorbox.close(), !1;
                    })
                    .on("click", "#colorbox .action-icons .prev-item, #colorbox .action-icons .next-item", function () {
                        return e("#".concat(e(this).data("idx"), " .quick-buy")).click(), theme.activeQuickBuyMediaGallery && theme.activeQuickBuyMediaGallery.destroy(), !1;
                    }),
                e(document).on("focusin focusout", ".toolbar .main-search__form input", function (t) {
                    e(this)
                        .closest(".main-search__form")
                        .toggleClass("focus", "focusin" == t.type);
                }),
                e(window).on("debouncedresize setminheight", a).trigger("setminheight"),
                e(function () {
                    a();
                }),
                e.extend(e.colorbox.settings, { previous: theme.strings.colorBoxPrevious, next: theme.strings.colorBoxNext, close: theme.strings.colorBoxClose }),
                document.querySelector(".shopify-challenge__container") && (document.getElementById("page-footer").style.display = "none"),
                theme.device.isTouch() && document.getElementsByTagName("html")[0].classList.add("touch"),
                window.addEventListener("pageshow", function (e) {
                    e.persisted && theme.updateCartSummaries(!1, !1, !1);
                }),
                theme.Sections.init(),
                theme.Sections.register("slideshow", theme.SlideshowSection),
                theme.Sections.register("header", theme.HeaderSection, { deferredLoad: !1 }),
                theme.Sections.register("footer", theme.FooterSection),
                theme.Sections.register("cart-drawer", theme.CartDrawerSection, { deferredLoad: !1 }),
                theme.Sections.register("collection-template", theme.FilterManager, { deferredLoad: !1 }),
                theme.Sections.register("product-template", theme.ProductTemplateSection),
                theme.Sections.register("blog-template", theme.BlogTemplateSection, { deferredLoad: !1 }),
                theme.Sections.register("cart-template", theme.CartTemplateSection, { deferredLoad: !1 }),
                theme.Sections.register("collection-listing", theme.CollectionListingSection, { deferredLoad: !1 }),
                theme.Sections.register("featured-collection", theme.FeaturedCollectionSection),
                theme.Sections.register("featured-collections", theme.FeaturedCollectionsSection),
                theme.Sections.register("background-video", theme.VideoManager),
                theme.Sections.register("gallery", theme.GallerySection),
                theme.Sections.register("announcement-bar", theme.AnnouncementBarSection, { deferredLoad: !1 }),
                theme.Sections.register("product-recommendations", theme.ProductRecommendations),
                theme.Sections.register("testimonials", theme.TestimonialsSection),
                theme.Sections.register("search-template", theme.FilterManager, { deferredLoad: !1 });
        }),
        e(function (e) {
            u.sections.length
                ? u.sections.forEach((e) => {
                      try {
                          var t = {};
                          void 0 !== e.deferredLoad && (t.deferredLoad = e.deferredLoad),
                              void 0 !== e.deferredLoadViewportExcess && (t.deferredLoadViewportExcess = e.deferredLoadViewportExcess),
                              theme.Sections.register(e.name, e.section, t);
                      } catch (i) {
                          console.error("Unable to register section ".concat(e.name, "."), i);
                      }
                  })
                : console.warn("Barry: No common sections have been registered.");
        }),
        window.SwymCallbacks || (window.SwymCallbacks = []),
        window.SwymCallbacks.push(function e() {
            var t = _swat.replayAddToCart;
            function i(e) {
                theme.updateCartSummaries(!1);
            }
            window._swat.replayAddToCart = function () {
                var e = arguments[2];
                (arguments[2] = function (t) {
                    e && i && (e(t), i(t));
                }),
                    t.apply(this, arguments);
            };
        }),
        (function () {
            var e = document.links;
            for (let t = 0, i = e.length; t < i; t++) e[t].hostname !== window.location.hostname && ((e[t].target = "_blank"), (e[t].rel = "noreferrer noopener"));
        })();
})(theme.jQuery);
